export const diccionario_eu = {
  hola: "Kaixo",
  Leida: "Irakurrita",
  Archivada: "Artxibatua",
  empleados: "Langileak",
  BloquearReserva: "Blokeatu Erreserba ",
  empleado: "Langilea",
  empezar: "hastea",
  empezada: "hasia",
  organizacion: "Antolaketa",
  estructura: "Egitura",
  organizativa: "antolatzailea",
  crear: "Sortu",
  visualizar: "Ikusi",
  modificar: "Aldatu",
  listados: "Zerrendak",
  listado: "Zerrenda",
  recursos: "Giza Baliabideak",
  resumen: "Laburpena",
  evaluados: "Ebaluatuak",
  evaluado: "Ebaluatua",
  evaluaciones: "Ebaluazioak",
  evaluacion: "Ebaluazioa",
  evaluada: "Ebaluatua",
  pruebas: "Probak",
  areas: "Arloak",
  evainiciadas: "Ebal. hasiak",
  abstencion: "Abstentzioa",
  evarealizadas: "Ebal. eginak",
  ranking: "Langileen sailkapena ebaluazioaren arabera",
  nombre: "Izena",
  Nombre: "Izena",
  apellidos: "Abizenak",
  area: "Arloa",
  estado: "Egoera",
  fecha: "Data",
  resultado: "Emaitza",
  todas: "Guztiak",
  año: "urtea",
  competencias: "gaitasunak",
  destacadas: "nabarmenduak",
  buenas: "onak",
  normales: "normalak",
  alejadas: "urrunak",
  submitida: "aurkeztua",
  submitidas: "aurkeztuak",
  submitir: "aurkeztu",
  completas: "osoak",
  periodos: "Aldiak",
  fomulario: "Inprimakia",
  actualizar: "Eguneratu",
  busqueda: "Bilaketa-eremuak",
  rellenar: "Bete eremu bat berreskuratu nahi duzun langilearen balioarekin",
  rellenar2: "Bete eremu bat berreskuratu nahi duzun egituraren balioarekin",
  limpiarcampos: "Garbitu eremuak",
  seleccionado: "hautatua",
  hombre: "Gizona",
  mujer: "Emakumea",
  otros: "Beste batzuk",
  genero: "Generoa",
  cargo: "Kargua",
  acceso: "Sarbidea",
  herramienta: "tresna",
  registro: "erregistroa",
  telefono: "Telefonoa",
  inicio: "hasiera",
  Bueno: "Ona",
  Destacado: "Nabarmendua",
  Alejado: "Urruntua",
  Normal: "Normala",
  sin: "Gabe",
  finalizar: "amaitu",
  aviso0: "Gutxienez galdetegiko galderen bat erantzun behar duzu ebaluazioa hasteko",
  aviso1: "Ebaluazioa amaitzeko, galdera guztiak erantzun behar dituzu",
  aviso2: "Ebaluazioa aurkezteko 'Aurkeztu' botoia aktibatu behar duzu",
  aviso3: "EBALUAZIOA AURKEZTU DA, edozein aldaketarako jarri harremanetan administratzailearekin",
  gerente: "Gerentea",
  observaciones: "Oharrak",
  aviso4: "Ebaluazioa berriro ireki nahi duzu?",
  aviso5: "Ebaluazioa aurkeztu nahi duzu? Behin aurkeztuta ezin izango duzu aldatu",
  deLaOrganizacion: "ANTOLAKETAREN (CORE)",
  PERSONALES: "PERTSONALAK",
  delPuesto: "LANPOSTUAREN",
  funcionales: "(FUNTZIONALAK)",
  INTERPERSONALES: "PERTSONARTEKOAK",
  delPuestoFuncionales: "LANPOSTUAREN (FUNTZIONALAK)",
  Email: "Email",
  Fecha_Creacion: "Alta data",
  Id: "Identifikatzailea",
  SOSBloqueo: "SOS",
  Codigo_seguridad: "Segurtasun kodea (gehienez 5 digitu)",
  Codigo_vecino: "Komunitatearen erregistro kodea",
  Cp: "P.K.",
  Poblacion: "Herria",
  Seguro_nombre: "Aseguru-etxea",
  tooltip: "Komunitateari lotutako aseguru-etxea",
  Poliza: "Poliza",
  IBAN: "IBAN kontua",
  Vecinos: "Auzokide kop.",
  Pago_App: "Hileroko APP ordainketa",
  Cif: "IFK",
  tip_comunidad: "Komunitateari lotutako aseguru-etxea",
  listaComunidades: "Komunitateen zerrenda",
  Direccion: "Helbidea",
  Provincia: "Probintzia",
  estadoComunidad: "Egoera",
  Altac365: "c365 alta",
  AltaC3652: "Alta",
  Fecha_Baja: "Baja data",
  Bloqueada: "Blokeatua",
  tip_Bloqueada: "Sakatu erabiltzaileen aplikaziorako sarbidea blokeatzeko/desblokeatzeko",
  tip_Alta: "365 komunitatea aktibatu/kontratatu",
  tip_Baja: "365 komunitatea desaktibatu/baja eman edo kontratuaren xehetasunak ikusi",
  tituloBloquear: "Komunitatea blokeatu",
  tituloDesBloquear: "Komunitatea desblokeatu",
  cuerpoBloquear: "Sakatu onartu komunitatearen blokeoa baieztatzeko",
  cuerpoDesBloquear: "Sakatu onartu komunitatearen desblokeoa baieztatzeko",
  tip_EnvioComunidades: "Aurrehautatutako komunitateei abisuak bidali",
  ENVIAR_AVISO: "Abisua bidali",
  ENVIAR_AVISO_DOCUMENTOS: "Dokumentazio abisua bidali",
  Buscar: "Bilatu",
  Buscador: "Bilatzailea",
  Inicio: "Hasiera",
  Comunidades: "Komunitateak",
  Incidencias: "Gorabeherak",
  Gremios: "Hornitzaileak",
  Roles: "Rolak",
  Notificaciones: "Jakinarazpenak",
  Despacho: "Bulegoa",
  Documentos: "Dokumentuak",
  Usuarios: "Erabiltzaileak",
  DescripcionMenuInicial: "Hasierako Menua deskribapena",
  CIF: "IFK",
  Administracion: "Administrazioa",
  AvisoLegal: "Lege-abisua",
  PoliticaPrivacidad: "Pribatutasun-politika",
  PoliticaCookies: "Cookie-politika",
  DescComunidades: "Komunitateen kudeaketa",
  DescIncidencias: "Gorabeheren kudeaketa",
  DescGremios: "Hornitzaileen kudeaketa",
  DescRoles: "Rolen kudeaketa",
  DescUsuarios: "Erabiltzaileen kudeaketa",
  DescNotificaciones: "Jakinarazpenen kudeaketa",
  DescAdministracion: "Bulegoko kudeaketa",
  Juntas: "Batzarrak",
  Votaciones: "Bozketak",
  VotacionesOrdenDia: "Eguneko ordena/Bozketak",
  ZonasComunes: "Gune komunak",
  Documentacion: "Dokumentazioa",
  Actividades: "Jarduerak",
  Actividad: "Jarduera",
  DescJuntas: "Batzarren kudeaketa",
  DescVotaciones: "Bozketen kudeaketa",
  DescZonasComunes: "Gune komunen kudeaketa",
  DescDocumentacion: "Dokumentazioaren kudeaketa",
  DescActividades: "Jardueren kudeaketa",
  Detalle: "Xehetasuna",
  Mostrando: "Erakusten",
  a: "a",
  de: "de",
  resultados: "emaitzak",
  HasSeleccionado: "Hautatu duzu",
  comunidades: "komunitateak",
  paraAviso: "abisua bidaltzeko",
  comunidad: "komunitatea",
  Comunidad: "Komunitatea",
  exportarPdf: "PDFra esportatu",
  exportarCsv: "CSVra esportatu",
  filasPagina: "Lerroak orrialdeko",
  comunidadesSeleccionadas: "komunitatea(k) hautatuta abisurako.",
  CERRAR: "ITXI",
  Restaurar: "Berrezarri",
  tituloFormAvisos: "Abisuak bidaltzea",
  asunto: "Gaia",
  textoAviso: "Abisuaren testua",
  URLopcional: "Aukerako URLa",
  diagoloTitulo: "Komunitateari baja ematea",
  diagoloBody: "Ziur zaude komunitateari baja eman nahi diozula?",
  cerrar: "Itxi",
  guardarCambios: "Gorde aldaketak",
  diagoloBodyAviso: "Ziur zaude abisua bidali nahi duzula?",
  diagoloTituloAviso: "Abisua bidaltzea",
  Guardar: "Gorde",
  CNAE: "CNAE",
  TlfnPrincipal: "Telefonoa (bat baino gehiago badago, komaz bereizita egon behar dute)",
  TlfnSecundario: "Bigarren telefonoa",
  Email1: "Emaila (bat baino gehiago badago, komaz bereizita egon behar dute)",
  Email2: "Emaila 2",
  idProveedor: "Hornitzaile IDa",
  idComunidad: "Komunitate IDa",
  fechaInicioContrato: "Kontratuaren hasiera data",
  fechaFinContrato: "Kontratuaren amaiera data",
  observaciones: "Oharrak",
  sinresultados: "Ez da emaitzarik aurkitu.",
  cancelar: "Ezeztatu",
  aceptar: "Onartu",
  Grupos: "Taldeak",
  AccesoATodo: "Guztira sarbidea",
  Documentacion: "Dokumentazioa",
  ZonasReserva: "Erreserba guneak",
  JuntasYVotaciones: "Batzarrak eta bozketak",
  Observaciones: "Oharrak",
  Opciones: "Aukerak",
  Acciones: "Ekintzak",
  tip_BorrarRol: "Sakatu rol bat ezabatzeko",
  confirmarBorradoRol: "Rol bat baja emateko markatu duzu, jarraitu nahi duzu?",
  tituloConfirmarBorradoRol: "Berretsi ezabaketa",
  Anadir: "Gehitu",
  Proveedores: "Hornitzaileak",
  SoloPara: "Bakarrik:",
  Roles: "Rolak",
  Numero: "Zenbakia",
  Portal: "Ataria",
  Escalera: "Eskailera",
  Piso: "Solairua",
  Letra: "Letra",
  Inquilino: "Maizterra",
  Multipropiedad: "Multipropietatea",
  Bloqueado: "Blokeatuta",
  Bloq: "Blokeo.",
  Usuario: "Erabiltzailea",
  AdministradorFincaColegiado: "Finka administratzaile kolegiatua",
  EmpleadoOficina: "Bulegoko langilea",
  RegistroHorario: "Fitxaketak",
  Ano: "Urtea",
  SeleccionaAno: "Aukeratu urte bat",
  Entrada: "Sarrera",
  Salida: "Irteera",
  Centro: "Zentroa",
  Horas: "Orduak",
  Semana: "Astea",
  Fecha: "Data",
  TotalHoras: "Orduak guztira",
  Minutos: "Minutuak",
  Modificar: "Aldatu",
  Eliminar: "Ezabatu",
  Filtrar: "Iragazi",
  tituloNuevoRegistroHorario: "Ordu-erregistro berria",
  confirmarBorradoRegistroHorario: "Ordu-erregistroa ezabatu nahi duzu?",
  tituloConfirmarBorradoRistroHorario: "Ordu-erregistroa ezabatu",
  EnviarCheckEmail: "Egiaztapen-mezuak bidali",
  tituloModificarRegistroHorario: "Ordu-erregistroa aldatu",
  MiCarpeta: "Nire karpeta",
  ReseteoContrasena: "Pasahitza berrezarri",
  TextoReseteoContrasena:
    "Erabiltzailearen pasahitza berrezarriko da, eguneraketa egin eta gero erabiltzaileak aplikaziora pasahitz berriarekin sartu beharko du",
  AnadeContrasena: "Gehitu pasahitz berria (gutxienez 6 digitu)",
  Borrar: "Ezabatu",
  Todo: "Dena",
  Reservas: "Erreserbak ",
  ReservasDe: "Erreserba libreak",
  Despachos: "Bulegoak",
  hasCambiadoDespacho: "Orain bulego honetan zaude",
  enviarAviso: "Abisua bidali",
  DNI: "NANa",
  descripcion: "Deskribapena",
  tipo: "Mota",
  EliminarUsuario: "Erabiltzailea ezabatu",
  ConfirmarEliminarUsuario: "Erabiltzailea ezabatu nahi duzu?",
  DetalleActividad: "Jardueraren xehetasuna",
  AnadirActividad: "Jarduera gehitu",
  tip_BorrarActividad: "Sakatu jarduera bat ezabatzeko",
  confirmarBorradoActividad:
    "Jarduera bat baja emateko markatu duzu, hau zure komunitate guztietatik desagertuko da, jarraitu nahi duzu?",
  tituloConfirmarBorradoActividad: "Berretsi ezabaketa",
  AnadirRol: "Rola gehitu",
  confirmarBorradoVoto: "Boto bat ezabatzeko markatu duzu, jarraitu nahi duzu?",
  tituloConfirmarBorradoVoto: "Berretsi ezabaketa",
  Icono: "Ikonoa",
  Si: "Bai",
  No: "Ez",
  cuerpoDesBloquearUsuario: "Erabiltzailea desblokeatu nahi duzu ",
  tituloDesBloquearUsuario: "Erabiltzailea desblokeatu ",
  cuerpoBloquearUsuario: "Erabiltzailea blokeatu nahi duzu ",
  tituloBloquearUsuario: "Erabiltzailea blokeatu ",
  Porcentaje: "Portzentajea",
  Proveedor: "Hornitzailea",
  SeleccionaProveedor: "Bilatu eta hautatu hornitzaile bat...",
  UsuariosRegistradores: "Erabiltzaile erregistratzaileak",
  FalloPago: "Ordainketak huts egin du, saiatu berriro geroago.",
  Gobierno: "Gobernu batzarra",
  Administración: "Administrazioa",
  Mantenimiento: "Mantentzea",
  tituloEnvioCorrecto: "Bidalitakoaren emaitza",
  mensajeResultados: "Abisua ongi bidali da ${var1} hartzaileei",
  tip_BorrarGremio: "Sakatu hornitzaile bat ezabatzeko",
  confirmarBorradoGremio: "Hornitzaile bat baja emateko markatu duzu, jarraitu nahi duzu?",
  tituloConfirmarBorradoGremio: "Berretsi ezabaketa",
  preciosSinIva: "Prezio guztiak BEZik gabe daude.",
  preciosPorVecino:
    "Prezioak komunitateko auzokide kopuruaren arabera aldatzen dira. (Komunitate honek ${var1} auzokide ditu)",
  preciosPorVecinoHistorico:
    "Prezioak komunitateko auzokide kopuruaren arabera aldatzen dira. (Komunitate honek ${var1} auzokide zituen kontratazioaren unean)",
  CreadoPor: "Nork sortua",
  estadoContrato: "Egoera",
  asociarActividad: "Jarduera orain komunitateko erabiltzaileen mugikorrean agertuko da.",
  desasociarActividad: "Jarduera jada ez da komunitateko erabiltzaileen mugikorrean agertuko.",
  asociarTodasActividades:
    "Orain jarduera guztiak komunitateko erabiltzaileen mugikorrean agertuko dira",
  desasociarTodasActividades:
    "Orain ez da komunitateko erabiltzaileen mugikorrean jarduerarik agertuko",
  EnvioAvisoEmail: "Abisuaz gain, posta elektronikoz ere bidali inplikatuei",
  Codigo: "Kodea",
  Tipo: "Mota",
  Actividad: "Jarduera",
  Registrador: "Nork erregistratua",
  tip_BorrarIncidencias: "Sakatu gorabehera ezabatzeko",
  tip_BorrarNotificaciones: "Sakatu jakinarazpena ezabatzeko",
  notificacionBorrada: "Jakinarazpena ezabatuta",
  tip_BorrarVotacion: "Sakatu bozketa ezabatzeko",
  tip_compartirIncidencia: "Gorabehera partekatu/argitaratu",
  tip_ModificarRegistroHorario: "Sakatu erregistroa editatzeko",
  tip_BorrarRegistroHorario: "Sakatu erregistroa ezabatzeko",
  tip_BorrarReserva: "Sakatu erreserba ezeztatzeko",
  tituloCriticos: "Datu kritikoak aldatu dira!",
  bodyCriticos:
    "Abonoak erabiltzaileei itzuliko zaizkie eta etorkizuneko erreserbak ezabatuko dira konfigurazioa gorde ahal izateko",
  Compartir: "Partekatu",
  red: "Gorria",
  yellow: "Horia",
  green: "Berdea",
  incidenciaGreen: "Gorabehera itxia edo ezeztatua",
  incidenciaYellow: "Gorabehera martxan",
  incidenciaRed: "Gorabehera 8 egun edo gehiagoz itxi gabe",
  incidenciaRed2: "Gorabehera irekia",
  ENVIAR_AVISO_EMAIL: "Erregistro-mezu elektronikoa bidali",
  adminDesk: {},
  SeleccionaComunidad: "Aukeratu komunitate bat",
  SeleccionaEstado: "Aukeratu egoera bat",
  SeleccionaActividad: "Aukeratu jarduera bat",
  SeleccionaProveedor2: "Aukeratu hornitzaile bat",
  Estado: "Egoera",
  ABIERTA: "IREKIA",
  CERRADA: "ITXITA",
  CANCELADA: "EZEZTATUA",
  ENCURSO: "MARTXAN",
  SeleccionaTipo: "Aukeratu mota",
  INCIDENCIA: "AVARIA",
  SINIESTRO: "EZBEHARRA",
  SOLICITUD: "ESKAERA",
  CONSULTA: "KONTSULTA",
  AVISO: "ABISUA",
  SOS: "SOS",
  NuevaIncidencia: "Gorabehera berria",
  DetalleIncidencia: "Gorabeheraren xehetasuna",
  DetalleVotacion: "Bozketaren xehetasuna",
  CodigoDespacho: "Bulegoko kodea",
  CodigoComunidad: "Komunitatearen kodea",
  SeleccionaRegistrador: "Aukeratu erregistratzaile bat",
  DescripcionIncidencia: "Gorabeheraren deskribapena (aplikazioko erabiltzaileek ikusgai)",
  DatosGuardadosCorrectamente: "Datuak ondo gorde dira.",
  ErrorGuardarDatos: "Errore bat gertatu da datuak gordetzean.",
  mensajeDespublicarIncidencia:
    "Aukera hau desaktibatzean, gorabehera pribatua izango da komunitateko auzokideentzat.",
  mensajePublicarIncidencia:
    "Aukera hau aktibatzean, gorabehera publikoa izango da komunitateko auzokide guztientzat. Edozein aldaketa eta ondorengo abisu bidalketa erregistratutako jabe guztiei egingo zaie.",
  Fecha_Modificacion: "Aldaketa data",
  EmailProveedor: "Hornitzailearen emaila",
  TelefonoProveedor: "Hornitzailearen telefonoa",
  ActualizaDescripcionInterna:
    "Gorabeheraren barne-oharrak (administratzaileek eta bulegoko langileek bakarrik ikusgai)",
  HistoricoDescripcionInterna: "Gorabeheraren historikoa",
  HistoricoDescripcionInternaVota: "Bozketaren historikoa",
  TituloBorrarIncidencia: "Berretsi gorabehera ezabaketa",
  CuerpoBorrarIncidencia: "Gorabehera ezabatutzat markatzeko sakatu onartu.",
  TituloCompartirIncidencia: "Berretsi gorabehera partekatzea",
  CuerpoCompartirIncidencia: "Gorabehera partekatzeko sakatu onartu.",
  IncidenciaBorradaCorrectamente: "Gorabehera ongi ezabatu da",
  errorBorrarIncidencia: "Errore bat gertatu da gorabehera ezabatzean",
  errorBorrarNotificacion: "Errore bat gertatu da jakinarazpena ezabatzean",
  NotificacionBorradaCorrectamente: "Jakinarazpena ongi ezabatu da",
  IncidenciaCompartidaCorrectamente: "Gorabehera ongi partekatu da",
  errorCompartirIncidencia: "Errore bat gertatu da gorabehera partekatzean",
  incidenciaBorrada: "Gorabehera ezabatua",
  votacionBorrada: "Bozketa ezabatua",
  notifiacionBorrada: "Jakinarazpena ezabatua",
  incidenciaCompartida: "Gorabehera partekatua",
  datosRefrescados: "Datuak freskatu dira",
  Documentacion: "Dokumentazioa",
  DocumentacionAdjunta: "Erantsitako dokumentazioa",
  DocumentacionAdjuntaDesc: "Gorabeherari lotutako dokumentuak",
  DocumentacionAdjuntaDesc2: "Jakinarazpenari lotutako dokumentuak",
  arrastraArchivos: "Arrastatu eta askatu hemen zure fitxategiak karpetara igotzeko",
  TextoPropiedadDocumentos:
    "* C365ra igotako dokumentu guztiak komunitatearenak dira, eta administratzailea aldatuz gero, transferituko dira. Dokumentu bat transferitu behar ez dela uste baduzu, adierazi ezazu dokumentu horren “Aldatu” aukeran",
  textoConfirmarBorradoCarpeta: "Ziur zaude karpeta ezabatu nahi duzula?",
  textoConfirmarBorradoCarpetaGeneral:
    "Ziur zaude karpeta ezabatu nahi duzula? Karpeta komunitate guztietatik ezabatuko da",
  tituloConfirmarBorradoCarpeta: "Karpeta ezabatu:",
  textoConfirmarBorradoFichero: "Ziur zaude fitxategia ezabatu nahi duzula?",
  textoConfirmarBorradoFicheroGeneral:
    "Ziur zaude fitxategia ezabatu nahi duzula? Fitxategia komunitate guztietatik ezabatuko da",
  tituloConfirmarBorradoFichero: "Fitxategia ezabatu:",
  ExitoBorradoFichero: "Fitxategia ongi ezabatu da",
  FalloBorradoFichero: "Errore bat gertatu da fitxategia ezabatzean",
  Descargar: "Deskargatu",
  SeleccionaCompaniaSeguros: "Aukeratu Aseguru-etxea",
  PolizaSeguros: "Aseguru-poliza",
  Direccion_es: "Helbidea(k)",
  PorcentajeTotalPropiedad: "% Guztira",
  TotalReservas: "Erreserba guztiak",
  PorcPropiedad: "% Jabetza",
  ViviendaInquilino: "Maizterra duen etxebizitza",
  ViviendaRepLegal: "Lege-ordezkaria duen etxebizitza",
  propietario: "Jabea",
  inquilino: "Maizterra",
  representantelegal: "Lege-ordezkaria",
  empresa: "Enpresa",
  ViviendasTipo: "Etxebizitzak / Mota",
  SinViviendas: "Etxebizitzarik gabe",
  AltaCorrecta: "Ongi eman da baja.",
  FalloBajaComunidad: "Errore bat gertatu da komunitateari baja ematean",
  ComunidadNoAlta: "Komunitatea ez dago alta emanda.",
  ErrorGuardadoDatos: "Errore bat gertatu da datuak gordetzean.",
  ErrorDatosExistentes: "Jarduera ${var1} jada existitzen da, mesedez erabili beste izen bat.",
  DatosActualizadosCorrectamente: "Datuak ongi eguneratu dira",
  ActividadBorradaCorrectamente: "Jarduera ongi ezabatu da",
  ActividadExistente: "Jarduera ${var1} jada existitzen da, mesedez erabili beste izen bat.",
  FechaAlta: "Alta data",
  CodigoVecino: "Auzokide kodea",
  CodigoPostal: "Posta Kodea",
  NumeroVecinos: "Auzokide kopurua",
  Siniestros: "Ezbeharrak",
  ModificacionClientes: "Eskaerak jaso",
  ConsultasAdmin: "Kontsultak jaso",
  ConsultasSeguros: "Aseguruen kontsultak",
  Categoria: "Kategoria",
  Alta: "Alta",
  ConfirmarBajaComunidad: "Ziur zaude c365ko ${var1} ID duen komunitateari baja eman nahi diozula?",
  MaximoArchivos: "Gehienez ${var1} fitxategi igo ditzakezu",
  TipoArchivoNoPermitido: "Baimendu gabeko fitxategi mota: ${var1}",
  ArchivoTamañoMaximoSuperado:
    "Fitxategia ${var1} baimendutako gehienezko tamaina (${var2} MB) gainditzen du",
  ArchivosSubidosCorrectamente: "Fitxategiak ongi igo dira.",
  NombreCarpetaVacio: "Karpetaren izena ezin da hutsik egon.",
  MismoNombreArchivoMismoNivel: "Ezin duzu izen bera jarri maila bereko dokumentu bati",
  CarpetaCreadaCorrectamente: "Karpeta ongi sortu da.",
  ErrorCrearCarpeta: "Errore bat gertatu da karpeta sortzean.",
  CarpetaMovidaCorrectamente: "Ficheiro/Karpeta ongi mugitu da.",
  ErrorMoverCarpeta: "Errore bat gertatu da fitxategia/karpeta mugitzean.",
  ErrorMoverCarpetaNoPermitido:
    "Ezin dituzu Propietarien Batzarren eta Dokumentazio Orokorraren karpetak mugitu",
  Carpeta03NoBorrar: "Propietarien Batzarren karpeta ezin da ezabatu/aldatu",
  GuardarCambiosModificar: "Aldaketak gordetzeko fitxategia aldatu behar duzu",
  ErrorCambiarTransferibilidad: "Errore bat gertatu da transferigarritasuna aldatzean",
  NombreCambiadoCorrectamente: "Izena ongi aldatu da.",
  ErrorCambiarNombre: "Errore bat gertatu da izena aldatzean.",
  TipoArchivoNoPermitido: "Baimendu gabeko fitxategi mota",
  DocumentosComunidad: "Komunitatearen dokumentuak",
  Busqueda: "Bilaketa",
  CarpetaActual: "Uneko karpeta :",
  NombreCarpeta: "Karpetaren izena",
  Descargar: "Deskargatu",
  Borrar: "Ezabatu",
  EnviarAviso: "Abisua bidali",
  AvisoDocumentosSubidosC365:
    "C365ra igotako dokumentu guztiak komunitatearenak dira, eta administratzailea aldatuz gero, transferituko dira. Dokumentu bat transferitu behar ez dela uste baduzu, adierazi ezazu dokumentu horren “Aldatu” aukeran",
  SeleccionarCarpetaMostrarDetalle: "Aukeratu karpeta bat bere xehetasuna ikusteko",
  TipoArchivoNoPermitido: "Baimendu gabeko fitxategi mota: ${var1}",
  TodoOk: "Dena ondo",
  GremioCreadoConecta: "Hornitzailea CAFPortal-ek sortu du edo ez du lotutako jarduerarik",
  ProveedorBaja: "Hornitzaileari baja eman zaio",
  CasoNoCompletado: "aztertu gabeko kasua",
  FechaAlta: "Alta data",
  FechaBaja: "Baja data",
  GremioBorradoCorrectamente: "hornitzailea ongi ezabatu da",
  Comus: "komus",
  CambioEstado: "Egoera-aldaketa",
  NotificacionUsuarioAceptarOCancelar:
    "Jakinarazpena bidali diezaiokezu erabiltzaile erregistratzaileari, administratzaileari eta mezu elektroniko bat hornitzaileari gorabeheraren eguneraketari buruz (MARTXAN) edo (IREKIA) sakatu ONARTU edo EZEZTATU",
  CambioEstadoIncidencia: "Gorabeheraren egoera-aldaketa",
  CambioEstadoIncidenciaCodigo:
    "Kodea ${var1} duen gorabeheraren egoera aldatu da ${var2}tik ${var3}ra",
  CambioEstadoIncidenciaCodigoCerrada: "Kodea ${var1} duen gorabeheraren egoera itxita dago ",
  ArchivoExcedeTamano: "Fitxategia baimendutako gehienezko tamaina (${var1} MB) gainditzen du",
  CambioTipo: "Mota-aldaketa",
  NotificacionIncidenciaAceptarOCancelar:
    "Jakinarazpena bidali diezaiokezu erabiltzaile erregistratzaileari, administratzaileari eta mezu elektroniko bat hornitzaileari gorabeheraren mota EZBEHARRAra aldatzeari buruz, sakatu “ONARTU” edo “EZEZTATU”.",
  CambioTipoIncidencia: "Gorabeheraren mota-aldaketa",
  CambiadoTipoIncidenciaCodigo: "Kodea duen gorabeheraren mota aldatu da ",
  CambiadoTipoAveriaCodigo:
    "Jakinarazpena bidali diezaiokezu erabiltzaile erregistratzaileari, administratzaileari eta mezu elektroniko bat hornitzaileari gorabeheraren mota AVARIAra aldatzeari buruz, sakatu “ONARTU” edo “EZEZTATU”.",
  FechaModificacion: "Aldaketa data",
  FechaCreacion: "Sorkuntza data",
  NombreRegistrador: "Erregistratzailearen izena",
  ApellidoRegistrador: "Erregistratzailearen abizena",
  RolExiste: "Rola ${var1} jada existitzen da, mesedez erabili beste bat.",
  DatosRefrescados: "Datuak freskatu dira",
  RolBorradoCorrectamente: "Rola ongi ezabatu da",
  LimpiarBusqueda: "Bilaketa garbitu",
  LimpiarSeleccionado: "Hautatutakoa garbitu",
  NoHayRoles: "Ez dago rolik",
  SeleccionarTodos: "Guztiak hautatu",
  SeleccionarTodosFiltrado: "Guztiak hautatu (iragazitakoak)",
  RolSeleccionado: "Hautatutako rola...",
  EmailYaExiste: "Emaila jada existitzen da",
  DNIYaExiste: "NANa jada existitzen da",
  NumeroYaExiste: "Zenbaki hau jada existitzen da komunitate honetako batzar baterako",
  TituloYaExiste: "Izenburu hau jada existitzen da komunitate honetako batzar baterako",
  CompletaCamposObligatiorio: "Mesedez, bete derrigorrezko eremu guztiak.",
  NoValidoIntroduceCorrecto: "NIF/NANa ez da baliozkoa, sartu zuzen bat",
  NoValidoIntroduceCorrecto2: "NIF/NAN/IFKa ez da baliozkoa, sartu zuzen bat",
  NoValidoIntroduceCorrecto3: "NIF/IFKa ez da baliozkoa, sartu zuzen bat",
  FotoBorradaCorrectamente: "Argazkia ongi ezabatu da.",
  FotoGuardadaCorrectamente: "Argazkia ongi gorde da.",
  AnadirUsuario: "Erabiltzailea gehitu",
  FechaIncorrecta: "Data okerra da.",
  NoFechasVacias: "Ezin da datetako bat hutsik utzi",
  HorasMinutos: "Orduak minutuak",
  RegistroHorarioBorrado: "Ordu-erregistroa ongi ezabatu da",
  ErrorBorrandoRegistro: "Errore bat gertatu da erregistroa ezabatzean",
  HoraSalidaEntradaIncorrecta: "Irteerako ordua ezin da sarrerakoa baino lehenagokoa izan",
  TodosRolesSeleccionados: "Rol guztiak hautatu dira.",
  SeleccionarRoles: "Rolak hautatu",
  RegistroInquilinoCambiado: "Maizterraren erregistroa aldatu da.",
  ErrorGuardarDatos: "Errore bat gertatu da datuak gordetzean",
  UsuarioEliminadoCorrectamente: "Erabiltzailea ongi ezabatu da.",
  FalloEliminarUsuario: "Errore bat gertatu da erabiltzailea ezabatzean.",
  DNIExisteOtroUsuario: "NANa jada existitzen da beste erabiltzaile batean",
  EmailExisteOtroUsuario: "Emaila jada existitzen da beste erabiltzaile batean",
  ContrasenaActualizadaNuevaContrasena: "Pasahitza eguneratu da. Pasahitz berria: ",
  EmailActualizado: "Erabiltzailearen izena eguneratu da. Erabiltzaile berria: ",
  ErrorCambiarContrsena: "Errore bat gertatu da pasahitza aldatzean.",
  ErrorCambiarEmail: "Errore bat gertatu da emaila/erabiltzailearen izena aldatzean.",
  ErrorEnviandoEmailConfirmacion: "Errore bat gertatu da egiaztapen-mezua bidaltzean: ",
  EnviadoCorreoConfirmacionA: "Egiaztapen-mezua honi bidali zaio: ",
  AltaC365: "c365 alta",
  CodigoCompletisimo: "kodea oso-osorik",
  VotoBorradoCorrectamente: "Botoa ongi ezabatu da",
  TipoVotacion: "Bozketa mota",
  Publicar: "Argitaratu",
  AperturaVotacion: "Bozketa ireki",
  ResultadoPublicado: "Emaitza argitaratuta",
  PublicadoPorPorciento: "%ren arabera argitaratua",
  AltaComunidadConfigurar:
    "Komunitate hau jada alta emanda daukazu c365-en, jarraitu ondorengo urratsak zure komunitatea konfiguratzeko:",
  BienvenidoC365: "Ongi etorri c365ra!",
  GeneraCodigoVecinos:
    "Egin ezazu auzokideengana Komunitatearen Erregistro Kodea edo Auzokidearen Erregistro Kodea, aplikazioan erregistratu ahal izateko.",
  CompletaDatosProveedoresGestionIncidencias:
    "Osatu zure kontratatutako hornitzaileen datuak gorabeherak eta ezbeharrak kudeatzeko.",
  MarcarActividades:
    "Markatu zure auzokideek gorabeherak igorri ahal izateko nahi dituzun jarduerak.",
  CompletaDocumentos: "Igo jabeekin partekatu nahi duzun dokumentazioa.",
  IncidenciasYproveedores:
    "Jarduera baten gorabeherak hornitzaile batengana zuzenean iristea nahi baduzu (administratzaileaz gain), eman alta hornitzaileetan edo jardueretan kontratuak.",
  SubeDocumentos: "Igo jabeekin partekatu nahi duzun dokumentazioa.",
  CreaVotacionesJuntas: "Prestatu bozketak eta batzarrak beharrezkoa denean.",
  CreaZonasComunes: "Konfiguratu gune komunak (Gune Komunen Packa kontratatuta baduzu).",
  HabilitaFichajes:
    "Egin ezazu auzokideengana Komunitatearen Erregistro Kodea edo Auzokidearen Erregistro Kodea, aplikazioan erregistratu ahal izateko.",
  SubeDoucmentacionComparte: "Igo nahi duzun dokumentazioa eta partekatu jabeekin.",
  PreparaVotacionesJuntas: "Prestatu bozketak edo batzarrak beharrezkoa denean.",
  ConfiguraZonasComunes: "Konfiguratu gune komunak (Gune Komunen Packa kontratatuta baduzu).",
  HabilitaEmleadosFichar:
    "Gaitu langileak fitxatu ahal izateko (Ordu Kontrol Packa kontratatuta baduzu).",
  MarcarEnviarAviso: "Markatu abisua bidaltzeko",
  MarcarEnviarAvisoRegistroVecino:
    "Markatu abisua bidaltzeko edo auzokidearen erregistro kodea bidaltzeko",
  UsuariosActivosComunidades: "Erabiltzaile Aktiboak / Komunitateak",
  UsuariosComunidad: "Komunitateko erabiltzaileak",
  ComunidadesActivasUsuarios: "Komunitate Aktiboak / Erabiltzaileak",
  ComusUsuarios: "Komus erabiltzaileak",
  IncidenciasEstados: "Gorabeherak/Egoerak ",
  EstadoNumero: "Egoera/Zenbakia",
  IncidenciasAverias: "Gorabeherak Avariak/Motak",
  IncidenciasTodas: "Gorabehera guztiak ",
  CodigoDespacho: "Bulegoko kodea",
  Refrescar: "Freskatu",
  Volver: "Itzuli",
  AltaDesde: "Alta data: hasiera",
  AltaHasta: "Alta data: amaiera",
  NOTIFICACIONES: "JAKINARAZPENAK",
  CUADRODEMANDOS: "AGINTE-TAULA",
  TODAS: "GUZTIAK",
  ACTIVAS: "AKTIBOAK",
  TODOS: "GUZTIAK",
  ACTIVOS: "AKTIBOAK",
  ABIERTA: "IREKIA",
  ENCURSO: "MARTXAN",
  CANCELADA: "EZEZTATUA",
  CERRADA: "ITXITA",
  Desde: "Dendetatik",
  Hasta: "Hona arte",
  hasta: "arte",
  bloquearReservaTitutlo: "Erreserba blokeatzea",
  CerrarSesion: "Saioa itxi",
  ErrorDemasiadosIntentos:
    "Saiakera gehiegi, mesedez itxaron pixka bat ekintza errepikatu aurretik.",
  ErrorCamposRequeridos:
    "Gorriz nabarmendutako eremuak derrigorrezkoak dira. Aldaketak gordetzeko beteta egon behar dute.",
  ValorAntiguo: "Aurreko balioa",
  ValorActual: "Uneko balioa",
  Estado: "Egoera",
  Tipo: "Mota",
  Actividad: "Jarduera",
  Proveedor: "Hornitzailea",
  NombreRegistrador: "Erregistratzailea",
  NombreResponsable: "Arduraduna",
  Texto_publicar: "Deskribapena",
  Email: "Emaila",
  Email2: "Emaila 2",
  Telefono1: "Telefonoa",
  Telefono2: "Telefonoa 2",
  Notas: "Barne oharrak",
  DerechoDeReservas: "Erreserba Eskubidea",
  sendRegistrationCodeModaltitle: "Erregistro kodea bidali",
  sendRegistrationCodeModalConfirm:
    "Ekintza honek beharrezko argibideak eta kredentzialak bidaliko dizkio posta elektronikoz erabiltzaileari aplikazioan erregistratzeko: ",
  sendRegistrationCodesModalConfirm:
    "Ekintza honek beharrezko argibideak eta kredentzialak bidaliko dizkio posta elektronikoz sisteman alta eman ez duten hautatutako erabiltzaile guztiei aplikazioan erregistratzeko.",
  sendRegistrationCodeModalSaveMail: "Emaila aldatu egin da, aldaketak gorde eta jarraitu?",
  sendRegistrationCodeAllowedTip: "Erregistro kodea posta elektronikoz bidali",
  sendRegistrationCodeDeniedTip: "Ezin da bidali emailik gabe",
  sendRegistrationCodeSucess: "Posta elektronikoa ongi bidali da.",
  sendRegistrationCodeFailure:
    "Posta elektronikoa bidaltzean arazo bat gertatu da, saiatu berriro geroago.",
  sendRegistrationCodesSucess: "Posta elektronikoak ongi bidali dira.",
  sendRegistrationCodesFailure:
    "Posta elektronikoak bidaltzean arazo bat gertatu da, saiatu berriro geroago.",
  sendRegistrationCodesMissingMail:
    " ez du postarik, sartu xehetasunean edo deselekzionatu erabiltzailea jarraitu aurretik.",
  RazonSocial: "Izen soziala",
  Correo: "Posta",
  PersonaDeContacto: "Harremanetarako pertsona",
  DatosDespacho: "Bulegoko datuak",
  NombreYapellidos: "Izen-abizenak",
  tituloBorradoIncidencia: "Gorabehera ${var1} ezabatua",
  tituloCompartidoIncidencia: "Gorabehera ${var1} partekatua",
  mensajeBorradoIncidencia:
    "Kodea ${var1} duen gorabehera ezabatu da, sakatu esteka xehetasunak ikusteko",
  mensajeCompartidoIncidencia:
    "Kodea ${var1} duen gorabehera partekatu da, sakatu esteka xehetasunak ikusteko",
  ResultadoPublicadoPorPorciento: "%ren arabera argitaratutako emaitza",
  ErrorNoArchivoBorrar: "Errore bat gertatu da, ez da ezabatzeko fitxategirik iritsi",
  PUBLICADA: "ARGITARATUA",
  NOPUBLICADA: "EZ ARGITARATUA",
  SINOABS: "BAI/EZ/ABS",
  OPCIONES: "AUKERAK",
  NuevaOpcionDeVotacion: "Bozketa-aukera berria",
  TituloBorrarVotacion: "Bozketa ezabatu",
  CuerpoBorrarVotacion: "Ziur zaude bozketa ezabatu nahi duzula?",
  AnadirVotacion: "Bozketa gehitu",
  ElFicheroExisteNoModificar: "Fitxategia ${var1} jada existitzen da eta ezin da aldatu",
  EnviarCambiosRealizados:
    "Egindako aldaketak erabiltzaileei eta administratzaileari bidaliko zaizkie",
  CambiarEstadoCerradaNoModificar:
    "Egoera ITXITAra aldatu nahi duzu?, aldatzen baduzu ezin izango duzu gorabehera gehiago aldatu",
  IncidenciaActualizadaCorrectamente: "Gorabehera ongi eguneratu da",
  IncidenciaCerradaCambioAdministrador:
    "Gorabehera itxita dago, aldaketarik egin nahi baduzu jarri harremanetan administratzailearekin, eskerrik asko",
  IncidenciaCanceladaCambioAdministrador:
    "Gorabehera ezeztatua dago, aldaketarik egin nahi baduzu jarri harremanetan administratzailearekin, eskerrik asko",
  IncidenciaNoExiste: "Gorabehera ez da existitzen.",
  BorrarEstadoAbierta: "Gorabeheraren egoera ezabatu ahal izateko IREKIA egon behar du",
  ArrastraFicheroCargarloVentana:
    "Arrastatu fitxategia edo egin klik hemen leiho batetik kargatzeko",
  CargarFicheroAdjuntarFoto: "Egin klik hemen fitxategi bat kargatzeko edo argazki bat eransteko",
  AnadeComentariosEnvialo: "Gehitu oharrak eta bidali",
  TextoAnadir: "Gehitzeko testua",
  NombreZona: "Gunearen izena",
  DescripcionIncidencia: "Gorabeheraren deskribapena",
  UltimaModificacion: "Azken aldaketa",
  GremioResponsable: "Hornitzaile Arduraduna",
  ImagenAsociada: "Lotutako irudia: ",
  Gremio: "hornitzailea: ",
  Incidencia: "Gorabehera: ",
  CentrosTrabajo: "Lan-zentroak",
  DocumentacionGeneral: "Dokumentazio orokorra",
  TodosCorreos: "Posta guztiak",
  RecibirIncidencias: "Avariak jaso",
  RecibirSiniestros: "Ezbeharrak jaso",
  RecibirModificacionClientes: "Eskaerak jaso",
  RecibirConsultaAdmin: "Administratzailearen kontsulta jaso",
  RecibirConsultaSeguros: "Aseguruen kontsultak jaso",
  RecibirConsultas: "Kontsultak jaso",
  CategoriaUsuarioAdministrador: "Erabiltzaile-Administratzaile kategoria",
  Rol: "Rola",
  Fichar: "Fitxatu",
  ResetearContrasena: "Pasahitza berrezarri",
  VerificarEmail: "Emaila egiaztatu",
  Eliminar: "Ezabatu",
  DetallesUsuario: "Erabiltzailearen xehetasunak",
  FechaUltimoAcceso: "Azken sarbide data",
  FechaCreacion: "Sorkuntza data",
  AnadirRegistro: "Erregistroa gehitu",
  HorasEntrada: "Sarrera orduak",
  HorasSalida: "Irteera orduak",
  Latitud: "Latitudea",
  Longitud: "Longitudea",
  Distancia: "Distantzia",
  VotacionaBorradaCorrectamente: "Bozketa ongi ezabatu da",
  AnadirCentroDeTrabajo: "Lan-zentroa gehitu",
  CodigoAdministrador: "Administratzailearen kodea",
  DatosCentroDeTrabajo: "Lan-zentroaren datuak",
  CentrosTrabajoDespacho: "Bulegoko lan-zentroak",
  CentrosTrabajoComunidad: "Komunitatearen lan-zentroak",
  AvisoActividadSinProveedor:
    "Administratzaileek beti jasoko dituzte gorabeherak jardueraren arabera, hornitzaile jakin batek ere jasotzea nahi baduzu, asoziatu ezazu hornitzailearen xehetasunetik.",
  AlertaIncidenciaCompartida:
    "Gorabehera jada partekatuta zegoen. Sartu xehetasunera partekatzea ezeztatzeko.",
  DocumentoAnadido: "Dokumentua gehituta",
  DocumentoEliminado: "Dokumentua ezabatuta",
  textoEnviarActualizaciones:
    "Bidali emailak eta jakinarazpenak inplikatuei gorabeheraren aldaketen berri emanez",
  tituloEnviarActualizaciones: "Berretsi gordetzea",
  tip_BorrarZonaComun: "Berretsi ezabaketa-eragiketa",
  confirmarBorradoZonaComun: "Ziur zaude gune komuna ezabatu nahi duzula?",
  ZonaComunBorradaCorrectamente: "Gune komuna ongi ezabatu da",
  tituloConfirmarBorrado: "Berretsi ezabaketa",
  UsuariosDespacho: "Bulegoko erabiltzaileak",
  zonaPiscina: "Igerilekua",
  zonaPadel: "Padel pista",
  zonaTenis: "Tenis pista",
  zonaSalaReuniones: "Bilera gela",
  zonaGimnasio: "Gimnasioa",
  zonaOtros: "Beste batzuk",
  zonaBarbacoa: "Barbakóa",
  zonaJardinJuegos: "Lorategia/Jolas-gunea",
  zonaFronton: "Frontoi",
  zonaSalaInfantil: "Haur-gela",
  zonaSolarium: "Solariuma",
  zonaSpa: "Spa",
  zonaPiscina2: "Igerilekua II",
  zonaBus: "Bus",
  CentroTrabajoCerradoCorrectamente: "Lan-zentroa ongi ezabatu da",
  tip_BorrarCentroTrabajo: "Sakatu lan-zentroa ezabatzeko",
  centroDeTrabajoBorrado: "Lan-zentroa ezabatua",
  CuerpoBorrarCentroTrabajo: "Lan-zentroa ezabatzeko sakatu onartu.",
  TituloBorrarCentroTrabajo: "Lan-zentroa ezabatzea berretsi",
  Historial: "Erreserben historikoa",
  tip_historialReservas: "Sakatu gune komunaren erreserben historikoa ikusteko",
  HoraInicio: "Hasiera ordua",
  HoraFin: "Amaiera ordua",
  Administrador: "Administratzailea",
  Oficial: "Ofiziala",
  Auxiliar: "Laguntzailea",
  CamposVacios: "Gorriz dauden eremuak ezin dira hutsik egon",
  SeleccionaUnaOpcion: "Aukeratu aukera bat",
  AnadirUsuario: "Erabiltzailea gehitu",
  PersonasIncluidas: "Sartutako pertsonak",
  Enteros: "Zenbaki osoak",
  AnadirZonaComun: "Gune komuna gehitu",
  DetalleZonaComun: "Gune komunaren xehetasuna",
  NombreZona: "Gunearen izena",
  TipoZona: "Gunearen mota",
  NumeroPersonasReserva: "Erreserba bakoitzeko baimendutako pertsona kopurua",
  NumeroReservasPorDia: "Erreserba kopurua eguneko/pertsonako",
  HorizonteDeFechas: "Data-horizontea",
  Aforo: "Edukiera",
  SlotsSeguidos: "Erreserba bakoitzeko onartutako slot jarraituak",
  AperturaDiaSiguiente: "Hurrengo eguneko erreserba ireki, honetatik aurrera:",
  LimitacionesReserva: "Onartu erreserba, baldin eta erreserba aktiboa bada",
  MostrarPortalPiso: "Erakutsi Ataria, Solairua, Letra nork erreserbatu duen",
  NoPermitirReservarSiReserva:
    "Ez onartu erreserba, baldin eta erreserba aktiboa ez bada kontsumitu",
  MargenCancelacionReserva: "Erreserba ezeztatzeko marjina",
  NumeroPersonas: "Pertsona kopurua",
  SeleccionaNumpersonas: "Aukeratu pertsona kopurua",
  SeleccionaNumreservas: "Aukeratu erreserba kopurua pertsona/eguneko",
  persona: "pertsona",
  personas: "pertsonak",
  reserva: "erreserba",
  reservas: "erreserbak",
  NoAplica: "Ez dagokio",
  dias: "egunak",
  dia: "egun",
  SeleccionaHorizonte: "Aukeratu egun kopurua",
  SeleccionaSlotsSeguidos: "Aukeratu zenbakia",
  Slot: "Slot",
  Slots: "Slotak",
  SeleccionaPermitirReservarHora: "Aukeratu ordua",
  limitaciones1: "MUGARIK GABE",
  limitaciones2: "Aplikazio-ordutik aurrera bakarrik, hurrengo egunerako",
  limitaciones3: "Erreserba aktiboaren egun berean bakarrik, egunekoak kontsumitu arte",
  limitaciones4: "Gutxieneko ordu-desberdintasunarekin bakarrik erreserbatu dezakezu",
  limitaciones5: "Hurrengo slota askatu ordu batzuk igaro ondoren",
  SeleccionaLimitaSiReserva: "Aukeratu aukera",
  LimiteHoraCancelacion: "Ezeztapen orduaren muga",
  Resetear: "Berrezarri",
  ResetearVotacionBody: "Ziur zaude bozketa berrezarri nahi duzula?",
  VotacionResetearCorrectamente: "Bozketa ongi berrezarri da",
  ZonaComunExiste:
    "Gune komuna ${var1} jada existitzen da komunitate honetan, mesedez idatzi beste izen bat.",
  ControlStockReservas: "Erreserben stock-kontrola",
  visibleSoloAdmin: "ADMINISTRATZAILEAK BAKARRIK IKUSGAI",
  limiteReservasUsuario: "Erreserba-muga/erabiltzaile",
  tipoControlStock: "Stock-kontrol mota",
  permitirReservarSinStock: "Stockik gabe erreserbatzea onartu",
  consumirStockReservaActual: "Stock-etik kontsumitu uneko orduan erreserbatzean",
  consumirStockAunCancelando: "Stock-etik kontsumitu, nahiz eta erreserba ezeztatu",
  noConsumirStockDiaReserva: "Ez kontsumitu stocka erreserba egun berean",
  tipoControlStock1: "Astean",
  tipoControlStock2: "Hilean",
  tipoControlStock3: "Urtean",
  tipoControlStock4: "Denboraldian",
  tipoControlStock5: "Egunetan",
  SeleccionaTipoControlStock: "Aukeratu mota",
  FechaInicio: "Hasiera data",
  FechaFin: "Amaiera data",
  FormaDePago: "Ordainketa modua",
  noConsumirDesdeDia: "Ez kontsumitu egun honetatik aurrera",
  noConsumirAPartir: "Ez kontsumitu stocka honetatik aurrera",
  desdedia0: "Egun bat ere ez lehenago",
  desdedia1: "egun bat lehenago",
  desdedia2: "egun batzuk lehenago",
  SeleccionaDiasAntesSinConsumir: "Aukeratu egunak",
  ControlAbonos: "Abonuen kontrola",
  ControlInvitados: "Gonbidatuen kontrola",
  AperturaAutomaticaPuerta: "Atea automatikoki irekitzea",
  GestionHorarios: "Ordutegien kudeaketa",
  NumInvitadosPorReserva: "Erreserba bakoitzeko gehieneko gonbidatu kopurua",
  NumConvivientesPorReserva:
    "Gune bakoitzeko eta erreserba bakoitzeko gehieneko bizikide ez-nominal kopurua. Aukera hau erabiltzaileak bizikide nominalak ez baditu aplikatzen da",
  minutosApertura: "Aktibatu irekiera minutu batzuk erreserba-ordua baino lehen",
  mantenerApertura: "Mantendu irekiera minutu batzuk itxi ondoren",
  AperturaAutomatica: "Atea automatikoki irekitzea",
  unCuartoDeHora: "Ordu laurden bat",
  mediaHora: "Ordu erdi bat",
  tresCuartosHora: "Hiru ordu laurden",
  unaHora: "Ordu 1",
  unaHoraYMedia: "Ordu bat eta erdi",
  Horas: "Orduak",
  HorasYMedia: "Ordu eta erdiak",
  HoraDeApertura: "Irekitze-ordua",
  HoraDeCierre: "Ixteko ordua",
  TamanoSlot: '"slot"aren tamaina',
  TodasComunidades: "Komunitate guztiak",
  DireccionPrincipal: "Helbide nagusia",
  EstablecerHorarioFindes: "Ordutegia ezarri asteburu eta jaiegunetarako",
  CalendarioDiasFestivos: "Jaiegunen egutegia",
  DireccionRepetida: "Helbidea jada sisteman dago",
  FestivosSeleccionados: "Jaiegunak",
  Enero: "Urtarrila",
  en: "urt",
  Febrero: "Otsaila",
  feb: "ots",
  Marzo: "Martxoa",
  mar: "mar",
  Abril: "Apirila",
  abr: "api",
  Mayo: "Maiatza",
  may: "mai",
  Junio: "Ekaina",
  jun: "eka",
  Julio: "Uztaila",
  jul: "uzt",
  Agosto: "Abuztua",
  ago: "abu",
  Septiembre: "Iraila",
  sep: "ira",
  Octubre: "Urria",
  oct: "urr",
  Noviembre: "Azaroa",
  nov: "aza",
  Diciembre: "Abendua",
  dic: "abe",
  Sabado: "Larunbata",
  sab: "lar",
  Domingo: "Igandea",
  dom: "iga",
  Lunes: "Astelehena",
  lun: "ast",
  Martes: "Asteartea",
  mar: "ast",
  Miercoles: "Asteazkena",
  mier: "ast",
  Jueves: "Osteguna",
  jue: "ost",
  Viernes: "Ostirala",
  vie: "ost",
  AnadirHorario: "Ordutegia gehitu",
  QuitarHorario: "Ordutegia kendu",
  HoraApertura: "Irekitze-ordua",
  HoraCierre: "Ixteko ordua",
  Sabados: "Larunbatak",
  Domingos: "Igandeak",
  Festivos: "Jaiegunak",
  AnadirQuitarFestivos: "Jaiegunak gehitu edo kendu",
  Fecha_Publicacion: "Argitaratze data",
  errorValidacionStock1:
    "Erreserben stock-kontrola erabiltzen baduzu, erreserba-muga gutxienez 1 izan behar du",
  errorValidacionStock2:
    "stock-kontrolaren denboraldiaren hasiera edo amaiera data ezin da hutsik egon",
  errorValidacionStock3:
    "stock-kontrolaren denboraldiaren hasiera eta amaiera data ezin da bera izan",
  AnadirEmpleado: "Langilea gehitu",
  mensajeErrorHoras: "Ixteko ordua ezin da Irekitze-ordua baino lehenagokoa izan",
  confirmarBorradoProveedor: "Ziur zaude hornitzailea ezabatu nahi duzula?",
  tituloConfirmarProveedor: "Berretsi hornitzailearen ezabaketa",
  UsuariosCongreso: "CNAF2024ko erabiltzaileak",
  Contrasena: "Pasahitza",
  Abonos: "Abonuen taula",
  AbonosLuz: "Argindarraren abonuen taula",
  ContratosAsoaciados: "Jarduerari lotutako kontratuak",
  SinContratos: "Lotutako kontraturik gabe edo hornitzailea conecta-tik dator",
  ConContratos: "Lotutako kontratuekin",
  TipoCobroAbono: "Abono-kobrantza mota",
  TipoCobroAbonoLuz: "Argindar-abonoaren kobrantza mota",
  Abonado: "Abonatua",
  CodigoAbono: "Abono kodea",
  StockActual: "Uneko stocka",
  Observaciones: "Oharrak",
  ReservasDisponiblesPorAbono: "Abono bakoitzeko eskuragarri dauden erreserbak",
  CosteEuros: "Kostua eurotan",
  TablaUsuariosAbono: "Abono erabiltzaileen taula",
  TiposPagos: "Ordainketa-motak",
  RecargaAbonoApp: "App-eko abonoa kargatu",
  RecargaAbonoLuz: "Argindar-abonoa kargatu",
  UsuariosAbonoLuz: "Argindar-abonoaren erabiltzaileak",
  TiposPagosLuz: "Argindar-ordainketa motak",
  HoraInicioLuz: "Argindar-hasiera ordua",
  HoraFinLuz: "Argindar-amaiera ordua",
  ABIERTO: "IREKITA",
  BLOQUEADO: "BLOKEATUTA",
  NoBorrarActividadGremiosAsociados: "Ezin da jarduera ezabatu hornitzaile lotuak dituelako",
  NoBorrarActividadIncidenciasAsociadas: "Ezin da jarduera ezabatu gorabehera lotuak dituelako",
  TodoCorrecto: "Dena zuzen",
  ContratoActividadExpiracion: "Jardueraren kontratua iraungitzear dago",
  DetectadoProveedorEliminadoDespacho:
    "c365-tik zure bulegoan hornitzaile bat ezabatu dela antzeman dugu, hornitzaile hau lotuta zegoen jardueratik ezabatu da, eta administratzaileari lotuko zaio",
  ActividadIncidenciasAbiertas: "Jarduerak gorabehera irekiak ditu lotuta, kode honekin: ",
  NoGremiosAsociados: "Ez dago hornitzaile loturik jarduerari",
  CentroDeTrabajoCreadoAnteriormente: "Lan-zentro hori jada sortu zen aurretik",
  Completado: "Osatuta",
  UsuarioCreadoAnteriormente: "Erabiltzaile hori jada sortu zen aurretik",
  AnchoYAltoImagen: "Irudiaren zabalerak 1054 pixel izan behar du eta altuerak 444 pixel",
  NoDatosDisponibles: "Ez dago datu erabilgarri",
  ReservasZonasComunes: "Gune komunen erreserbak",
  GestionReservas: "Erreserben kudeaketa",
  CodigoDebeSerNumero: "Kodeak zenbaki bat izan behar du",
  ElCodigo: "Kodea ",
  CoincideConOtraComunidad: " beste komunitate batekoarekin bat dator",
  VerContratos: "Kontratuak ikusi",
  ExisteEvaluacionNombreCambialo:
    "Jada existitzen da izen hori duen ebaluazio bat, mesedez aldatu izena sortu ahal izateko",
  PruebaActualizadaCorrectamente: "Proba ongi eguneratu da",
  TituloEvaluacion: "Ebaluazioaren titulua",
  CampoObligatorio: "eremu hau derrigorrezkoa da",
  FechaCreacion: "Sorkuntza data",
  SeleccionAreasEvaluacion: "Aukeratu ebaluazioari aplikatzen zaizkion arloak",
  SeleccionPruebasEvaluacion: "Aukeratu ebaluazio honetarako probak",
  FechaInicio: "Hasiera data",
  FechaInicialEvaluacionAntesFinal:
    "Ebaluazioaren hasierako data amaierako data baino lehenagokoa izan behar da",
  FechaFinEvaluacion: "Ebaluazioaren amaiera data",
  CambiarNombreDe: "Izen hau aldatu: ",
  AnadirNombreCarpetaFichero: "Gehitu fitxategi/karpeta bati jarri nahi diozun izena",
  EnvioAvisoPrueba: "proba abisua bidali",
  NombreDeUsuario: "Erabiltzailearen izena",
  SinComunidadAsociada: "Lotutako komunitaterik gabe",
  SinActividadAsociada: "Lotutako jarduerarik gabe",
  Contratos: "Kontratuak",
  AnadirContrato: "Kontratua gehitu",
  seleccionarComu2: "Komunitate guztietan ezkutua",
  DebesSeleccionarComunidadAnadirContrato:
    "Kontratu bat gehitzeko komunitate bat hautatu behar duzu",
  DebesSeleccionarActividadAnadirContrato: "Kontratu bat gehitzeko jarduera bat hautatu behar duzu",
  DebesSeleccionarFechaInicioAnadirContrato:
    "Kontratu bat gehitzeko hasiera data bat hautatu behar duzu",
  YaExisteContratoParaActividadEnComunidad:
    "Jada existitzen da jarduera honetarako kontratu bat komunitate honetan",
  YaExisteContratoParaActividadEnComunidad2:
    "Jada existitzen da jarduera honetarako kontratu bat komunitate honetan eta egungo hornitzailean",
  ContratoAnadidoCorrectamente: "Kontratua ongi gehitu da",
  ContratoEliminadoCorrectamente: "Kontratua ongi ezabatu da",
  Indefinido: "Mugarik gabe",
  VerIncidenciasDe: "Gorabeherak ikusi: ",
  DetalleProveedor: "Hornitzailearen xehetasuna",
  ErrorBorrarArchivoCarpeta: "Errore bat gertatu da fitxategia/karpeta ezabatzean: ",
  DocumentacionDeLaIncidencia: "Gorabeheraren dokumentazioa",
  SinHorasRegistradas: "Ordu erregistratu gabe",
  DireccionRepetida: "Helbidea errepikatuta dago",
  ValorEnterosNumerico: "Zenbaki osoen balioak zenbakizkoa izan behar du",
  NoDejarEnterosVacios: "Ezin dituzu zenbaki osoak hutsik utzi",
  NoDejarReservasVacias: "Ezin dituzu erreserba eskubideak hutsik utzi",
  NoDejarDireccionVacia: "Ezin duzu helbidea hutsik utzi",
  RegistroRepresentanteCambiado: "Ordezkaritza-erregistroa aldatu da.",
  ImagenUsuario: "Erabiltzailearen irudia",
  ImagenPorDefecto: "Lehenetsitako irudia",
  AnadirAlMenosUnaOpcionVotacion: "Bozketa aukera bat gutxienez gehitu behar da",
  NoAnadirOpcionRepetida: "Ezin duzu aukera errepikaturik gehitu",
  NoAnadirOpcionVacia: "Ezin duzu aukera hutsik gehitu",
  MostrarVotacionesBorradas: "Bozketa ezabatuak erakutsi",
  OcultarVotacionesBorradas: "Bozketa ezabatuak ezkutatu",
  VotacionCerrada: "Bozketa itxita",
  VotacionPublicada: "Bozketa argitaratua",
  VotacionAbiertaPublicada: "Bozketa irekia eta argitaratua.",
  VerLog: "Loga ikusi",
  AnadirBono: "Bono berria gehitu",
  TituloBajaAbono: "Abonoa ezabatu",
  ConfirmarBajaAbono: "Ziur zaude abonoa ezabatu nahi duzula?",
  TituloBajaTipoAbono: "Abono mota ezabatu",
  TituloBajaTipoAbonoLuz: "Argindar-abonoaren mota ezabatu",
  ConfirmarBajaTipoAbono: "Ziur zaude abono-mota ezabatu nahi duzula?",
  ConfirmarBajaTipoAbonoLuz: "Ziur zaude argindar-abonoaren mota ezabatu nahi duzula?",
  ProblemaNoPodidoEnviar: `Arazo bat egon da eta ezin izan da bidali`,
  AvisoEnviadoCorrectamenteA: "Aviso ongi bidali da ",
  destinatarios: " hartzaileei",
  FalloEnviarAviso: "Fallo bat gertatu da abisua bidaltzean: ",
  SoloPuedesSubirUnArchivo: "Fitxategi bakarra igo dezakezu",
  NoPuedesDejarTipoVacio: "Ezin duzu mota hutsik utzi",
  FalloEnElPago: `FALLO BAT GERTATU DA ORDAINKETAN`,
  ErrorAbrirNuevaVentanaPermisosVentanas:
    "Errore bat gertatu da leiho berria irekitzean, ziurtatu baimenak dituzula leiho gainerakorrak irekitzeko.",
  ContratoAceptadoPagosIniciados: "Kontratua onartua eta ordainketak hasita.",
  ArrastraSueltaArchivosSubirlosCarpeta:
    "Arrastatu eta askatu hemen zure fitxategiak karpetara igotzeko:",
  AnadirTipoBono: "Abono mota gehitu",
  AnadirTipoBonoLuz: "Argindar-abonoaren mota gehitu",
  AlertaGuardarCambios: "Aldaketak egin dituzu taulan, aldaketak gordetzeko sakatu 'Gorde'.",
  ProveedorBajaEnComunidades: "Hornitzaileari baja eman zaio komunitate/etan",
  FInicio: "H. Inicio",
  FFin: "H. Fin",
  Contratar: "Kontratatu",
  AceptarTerminosContratacion: "Kontratazio-baldintzak onartu",
  VolverPrimerPaso: "1. urratsera itzuli",
  DetalleComunidad: "Komunitatearen xehetasuna",
  Juntas: "Batzarrak",
  MensajeRecargaAbonos:
    "Jarri harremanetan laguntza-zerbitzuarekin komunitatearen datuak eta IBANa emateko, ordainketa-plataforma konfiguratu ahal izateko",
  MensajeAperturaAutomatica:
    "Jarri harremanetan laguntza-zerbitzuarekin komunitatearen datuak eta IBANa emateko, ordainketa-plataforma konfiguratu ahal izateko atea automatikoki irekitzeko instalazioa egiteko",
  Reservar: "Gunea erreserbatu",
  BloquearReservas: "Gune komuna blokeatu",
  seleccionaSlot: "Aukeratu slota(k)",
  SeleccionaUsuario: "Aukeratu erabiltzaile bat",
  comunidadActiva: "Komunitate aktiboa",
  comunidadInactiva: "Komunitate honek ez du alta emanda C365-en",
  comunidadBloqueada: "Gogoratu komunitate hau blokeatuta dagoela",
  NumeroJunta: "Batzar zk.",
  Titulo: "Titulua",
  confirmarBorradoJunta: "Sakatu onartu batzarra ezabatzeko",
  AnadirJunta: "Batzarra gehitu",
  FechaCelebracion: "Ospaketa data",
  tip_BorrarJunta: "Batzarra ezabatu",
  NumeroAsistentes: "Asistente kopurua",
  JuntasComunidad: "Komunitatearen batzarrak",
  AbrirConexion: "Batzarra ireki",
  CerrarConexion: "Batzarra itxi",
  Abierta: "Irekia",
  Cerrada: "Itxita",
  VideoComunidad: "Komunitatearen bideokonferentzia",
  Entrar: "Sartu",
  Junta: "Batzarra",
  TextoAyudaActividades1:
    "Aukeratu komunitate honetako auzokideek gorabeherak bidali ahal izateko nahi dituzun jarduerak.",
  TextoAyudaActividades2:
    "Hautatutako jardueren ikonoak bakarrik agertuko dira komunitate honetako auzokideen mugikorrean.",
  TextoAyudaActividades3: "Administratzaileek gorabehera GUZTIAK jasoko dituzte.",
  TextoAyudaActividades4:
    "Administratzaileaz gain, hornitzaile batek jarduera baten gorabeherak jasotzea nahi baduzu, asoziatu ezazu jardueraren edo hornitzailearen xehetasunetik.",
  JuntaCerradaPestanaCerrandose: "Bideokonferentzia itxi da, uneko fitxa 10 segundotan itxiko da",
  HabilitarQR: "QRa gaitu",
  irAlEnlace: "Egin klik hemen esteka kopiatzeko",
  tip_BorrarUsuarioWeb: "Webgunean sortutako erabiltzailea ezabatu",
  tip_BorrarUsuarioConecta: "Ezin da integrazioaren bidez inportatutako erabiltzaile bat ezabatu",
  cuerpoEliminarUsuario: "Erabiltzailea ezabatu nahi duzu ",
  tituloEliminarUsuario: "Erabiltzailea ezabatu ",
  ActivarUsuarioApp: "APP aktibatu erabiltzailearentzat",
  TextoActivarUsuarioApp:
    "Erabiltzailea APPn aktibatzeko, mesedez, idatzi pasahitz bat eta sakatu onartu.",
  EmailVerificado: "Emaila egiaztatuta",
  ErrorVerificacionEmail: "Errore bat gertatu da emaila egiaztatzean",
  ErrorBajaUsuario: "Errore bat gertatu da erabiltzaileari baja ematean",
  ProcesoActivacionCompleto: "Erabiltzailea aktibatzeko prozesua ongi amaitu da",
  tituloBajaUsuarioAPP: "Erabiltzailea desaktibatu",
  textoBajaUsuarioAPP: "Sakatu onartu erabiltzaileari APPn baja emateko",
  ProcesoDesactivacionCompleto: "Erabiltzailea desaktibatzeko prozesua ongi amaitu da",
  tip_usuarioActivado:
    "APPra sarbidea duen erabiltzailea. Sakatu erabiltzailearen APPrako sarbidea desaktibatu nahi baduzu.",
  tip_usuarioDesactivado:
    "APPra sarbiderik ez duen erabiltzailea. Sakatu erabiltzailearen APPrako sarbidea aktibatu nahi baduzu.",
  tip_usuarioSinValidar:
    "Erabiltzailea erregistratuta dago baina oraindik ez du bere email-kontua balioztatu.",
  amarillo_faltanDatosUsuario:
    "Hau/ek falta dira: [${var1}], mesedez, osatu komunitate honetako erabiltzaileen datuak zure ERP-an, CAFPortal-ek C365-en txertatu ahal izateko",
  amarillo_usuarioNoRegistrado: "Erabiltzaile hau oraindik ez dago erregistratuta C365-en",
  amarillo_usuarioViviendaNoAsignada: "Erabiltzaile honek ez du etxebizitza esleituta",
  amarillo_usuarioFalloFichaje:
    "Irteera-erregistrorik falta da egun hauetako fitxaketetan: ${var1}",
  amarillo_usuarioCamposVacios:
    "Hau/ek falta dira: [${var1}], mesedez, osatu komunitate honetako erabiltzaileen datuak zure ERP-an, CAFPortal-ek C365-en txertatu ahal izateko",
  amarillo_usuarioNoValidado: "Erabiltzaile honek ez du bere email-kontua balioztatu",
  rojo_usuarioBloqueado: "Gogoratu erabiltzaile hau blokeatuta dagoela",
  verde_usuarioCorrecto: "Erabiltzaile zuzena",
  tip_publicarJunta: "Batzarra argitaratu/desargitaratu",
  confirmarPublicacionJunta: "Sakatu onartu batzar hau argitaratzeko",
  tituloConfirmarPublicacion: "Batzarra argitaratu",
  confirmarDespublicacionJunta: "Sakatu onartu batzar hau desargitaratzeko",
  tituloConfirmarDespublicacion: "Batzarra desargitaratu",
  JuntaPublicadaCorrectamente: "Batzarra ongi argitaratu da",
  errorBorrarIncidencia: "Errore bat gertatu da batzarra argitaratzean",
  errorAbrirJunta: "Errore bat gertatu da konexioa irekitzean",
  Asistentes: "Asistenteak",
  asistentes: "asistenteak",
  activado: "aktibatua",
  desactivado: "desaktibatua",
  Asistente: "Asistentea",
  asistente: "asistentea",
  ControlAsistenciaUsuarios: "Erabiltzaileen asistentzia-kontrola",
  Viviendas: "Etxebizitzak",
  Vivienda: "Etxebizitza",
  Conexiones: "Konexio kop.",
  HoraEntrada: "Azken sarrera",
  HoraSalida: "Azken irteera",
  TotalDuracion: "Iraupen osoa (minutuak)",
  confirmarBorradoAsistente: "Ziur zaude batzarreko asistentea ezabatu nahi duzula?",
  tituloConfirmarBorradoAsistente: "Berretsi asistentea ezabatzea",
  RolBorradoCorrectamente: "Asistentea ongi ezabatu da",
  tip_BorrarAsistente: "Sakatu asistente bat ezabatzeko",
  TipoAsistencia: "Asistentzia-mota",
  NoCentroNoFichar: "Ezin duzu fitxatu lan-zentrorik esleituta ez baduzu",
  asistirJunta: "Balioztatu",
  CodigoCopiadoPortapapeles: "Kodea arbelean kopiatuta",
  ProveedorLocalAnadido:
    "C365 CAFPortal-etik hornitzaile berri bat antzeman dugu zure bulegoan, modulu lokaletik sortua. Datuak zuzenak diren egiaztatu dezakezu eta jarduera bati lotu.",
  tip_EnvioUsuarios: "Aurrehautatutako erabiltzaileei abisua bidali",
  tip_EnvioCodVec: "Aurrehautatutako erabiltzaileei erregistro-emaila bidali",
  NoSoyPropietario: "Ez naiz jabea",
  placeholderObservaciones: "Mesedez, adierazi batzar honetara etortzeko arrazoia",
  ErrorGuardandoAsistencia: "Errore bat gertatu da asistentzia gordetzean",
  AsistenciaRegistradaConExito: "Zure asistentzia ongi erregistratu da.",
  ReservaCompleta: "Erreserba beteta",
  EmpleadoComunidad: "Komunitateko langilea",
  JuntaAsociada: "Lotutako batzarra",
  ErrorFechasContrato: "Hasiera-data ezin da amaiera-data baino beranduagokoa izan",
  ErrorProveedorContrato: "Hornitzailea ezin da hutsik egon",
  ErrorFechaInicioMayor: "Hasiera-data ezin da amaiera-data baino beranduagokoa izan",
  SinJuntaAsociada: "Lotutako batzarrik gabe",
  EmailNoValidoIntroduceCorrecto: "Emaila ez da baliozkoa, sartu zuzen bat",
  verde_UsuarioRegistrado: "Erabiltzailea C365-en erregistratua",
  verde_UsuarioNoRegistrado: "Erabiltzailea C365-en erregistratu gabe",
  ErrorEmailVacio: "Erabiltzailea erregistratzeko beharrezkoa da erabiltzaileak email bat izatea",
  EmailNoValido: "Emaila ez da baliozkoa",
  Conexion: "Konexioa",
  InactivarProveedorConContratos:
    "Ezin da hornitzaile bat desaktibatu kontratu lotuak dituelako. Mesedez, ezabatu kontratuak hornitzailea desaktibatu aurretik",
  TiempoAcumulado: "Metatutako denbora",
  QR: "QR kodea",
  MostrarQR: "QRa erakutsi",
  FormularioAsistencia: "Batzarrera etortzeko inprimakia",
  EnlaceQRNoDisponible: "Asistentzia-inprimakiaren QR kodea ez dago gaituta.",
  verObservaciones: "Oharrak ikusi",
  ocultarObservaciones: "Oharrak ezkutatu",
  Enviar: "Bidali",
  tituloFormAvisosJuntas: "Batzarraren abisua bidali",
  Asociados: "Kontratu aktualak",
  AsociadosHistoricos: "Kontratu historikoak",
  BorrarActividadContrato: "Kontratua ezabatu",
  tituloConfirmarContrato: "Berretsi kontratuaren ezabaketa",
  confirmarBorradoContrato: "Ziur zaude kontratua ezabatu nahi duzula?",
  ContratosHistoricos: "Kontratu historikoak",
  guardarEnPdf: "QRa deskargatu",
  notiArchi: "Jakinarazpena ongi artxibatu da",
  SinUsuarios: "Lan-zentroari lotutako erabiltzailerik gabe",
  PlantillaConvocatoria: "Deialdia deskargatu",
  PlantillaActa: "Ebapena Akta deskargatu",
  Convocatoria: "Deialdia",
  Acta: "Akta",
  PrimeraConvocatoria: "Lehen deialdiaren ordua",
  SegundaConvocatoria: "Bigarren deialdiaren ordua",
  LugarCelebracion: "Ospaketa-lekua",
  ORDINARIA: "Arrunta",
  EXTRAORDINARIA: "Ezohikoa",
  ZonaBien: "Gune komuna ongi konfiguratuta",
  ZonaFestivosMal:
    "Gune komunak jaiegunetako ordutegiaren laukia markatuta du baina ez du ordutegirik konfiguratuta",
  ZonaHorariosBloqueados: "Gune komunak ordutegi blokeatuak ditu",
  ordenDiaStandar1: "Urteko kontuen onarpena, bidezkoa bada.",
  ordenDiaStandar2: "Gastuen eta diru-sarreren aurrekontu arrunta onartzea, bidezkoa bada.",
  ordenDiaStandar3:
    "Karguen aldaketa eta Gobernu Batzorde berriaren izendapena (Presidente, Lehendakariorde, Bokalak eta Administratzailea)",
  ordenDiaStandar4: "Karguen aldaketa gobernu batzarrean",
  ordenDiaStandar5: "Galde-eskeak",
  ordenDiaStandar1Desc: "",
  ordenDiaStandar2Desc: "",
  Convocante: "Deitzailea",
  juntaCerradaPorApertura:
    "Aurretik irekitako bideokonferentzia itxi da, konexio berria ahalbidetzeko",
  ErrorJuntaNoPublicada: "Ezin duzu konexioa ireki batzarra argitaratuta ez badago",
  Abrir: "Ireki",
  Descripcion: "Deskribapena",
  Junta: "Batzarra",
  Nombre: "Izena",
  Publicar: "Argitaratu",
  PublicarPorcentaje: "Portzentajea argitaratu",
  PublicarResultado: "Emaitza argitaratu",
  Roles: "Rolak",
  Vacio: "Hutsik",
  Votode: "BOTOA",
  hasioeliminao: "EZABATU EGIN DA",
  QRasistencia: "QR asistentzia",
  CheckboxVotaciones: "Eguneko ordena / Bozketak",
  TooltipVotaciones: "Batzarraren deialdiari lotutako bozketak sartu",
  LibresDe: "Gabe libre",
  BLOQUEAEDA: "BLOKEATUTA",
  SalaCompleta: "Gela beteta",
  BloquearDesbloquear: "Egun osoa blokeatu/desblokeatu",
  TituloBorrarReserva: "Erreserba ezeztatu",
  CuerpoBorrarReserva: "Ziur zaude erreserba ezeztatu nahi duzula?",
  camposCriticos:
    "Administratzaileak gune komunaren datu kritikoak aldatu ditu, stocka berreskuratu da ",
  camposCriticosSinAbono:
    "Administratzaileak gune komunaren datu kritikoak aldatu ditu, zure erreserba(k) anulatu dira: ",
  tituloCamposCriticos: "Stocka berreskuratzea",
  tituloCamposCriticosSinAbono: "Erreserba anulatzea",
  AlertaNumPersonasAforo:
    "Erreserba bakoitzeko baimendutako pertsona kopurua ezin da gunearen gehienezko edukiera baino handiagoa izan: ${var1}",
  labelLimitaciones2: "Aplikazio-ordua",
  labelLimitaciones4: "Gutxieneko ordu-desberdintasuna",
  labelLimitaciones5: "Orduak askatu arte",
  seleccionaHoraLimitacion: "Aukeratu ordua",
  NoAsistido: "Ez du parte hartu",
  AlertaSeCerraraConexion: "Batzarra desargitaratzean konexioa ere itxiko da.",
  Anulacion: "Erreserba anulatu da",
  haCanceladoReserva: "erreserba ezeztatu du",
  ParaElDia: "Egun honetarako",
  para: "rako",
  verDetalleEnvio: "Bidalitakoaren xehetasuna ikusi",
  seHaReservado: "erreserbatu da",
  haReservado: "erreserbatu du",
  enNombreDe: "honen izenean",
  reservaZonaComun: "Erreserbaren baieztapena",
  adminBloqueoReserva: "Administratzaileak erreserba blokeatu du",
  delDia: "eguneko",
  ContratoActividadExpirado: "Jardueraren kontratua iraungi da",
  SinContrato: "Kontraturik gabe",
  rolEncontradoUsu: "Rola ezabatu daiteke, erabiltzaileetan komunitateetan esleituta dagoelako",
  rolEncontradoVota: "Rola ezabatu daiteke, bozketetan komunitateetan esleituta dagoelako",
  enLasVotaciones: " eta bozketetan",
  rolEncontradoJuntas: "Rola ezabatu daiteke, batzarretan komunitateetan esleituta dagoelako",
  enLasJuntas: " eta batzarretan",
  ningunaDeLasPropuestas: "Proposamenetako bat ere ez",
  resultadoEscrutinio: "Eskrutinioaren emaitza",
  Escrutinio1: "botoen ⅓",
  Escrutinio2: "Gehiengo sinplea",
  Escrutinio3: "Gehiengo indartua",
  Escrutinio4: "asistenteen ⅗ parte",
  Escrutinio5: "Aho batez",
  tooltipEscrutinio2: "Botoen erdia baino gehiago edo partaidetza-kuotaren %50 baino gehiago",
  tooltipEscrutinio3:
    "⅗ parte. Ez-asistenteen botoak gehiengoaren botoei gehitzen zaizkie, eta hauek hilabete bat dute beren botoa ezeztatzeko. Ezin da akta sortu hilabetea pasatu arte",
  NaturalezaVotacion: "Bozketaren izaera",
  ResultadoVotacion: "Bozketaren emaitza",
  Aprobada: "Onartua",
  NoAprobada: "Ez onartua",
  ConclusionesVotacion: "Bozketaren ondorioak",
  Conclusiones: "Bozketaren ondorioak",
  configuracionCorrecta: "Konfigurazio zuzena",
  contratoActivo: "Kontratu aktiboa",
  contratoCaducado: "Kontratu iraungia, hornitzaileari abisuak iristen jarraituko diote",
  Nombre: "Izena",
  Apellido: "Abizena",
  Email: "Emaila",
  DNI: "NIF/NAN/IFK",
  DNI2: "NIF/IFK",
  Telefono: "Telefonoa",
  BuscarEnTodos: "Eremu guztietan bilatu",
  AnularReserva: "Ezeztatu",
  ErrorCancelarReserva: "Ezin da erreserba ezeztatu/blokeatua den bat ezeztatu",
  DetalleNotificacion: "Jakinarazpenaren xehetasuna",
  DocumentacionNotificacion: "Jakinarazpenaren dokumentazioa",
  IrDetalleIncidencia: "Lotutako gorabehera ikusi",
  CuerpoBloqueoNotificacion:
    "Jakinarazpena ezabatzean, hura jaso duten erabiltzaileek ezingo dute sartu eta ikusi",
  TituloBloqueoNotificacion: "Berretsi jakinarazpena ezabatzea",
  Leida: "Lida",
  FechaLectura: "Irakurketa-data",
  IdUsuario: "Erabiltzaile IDa",
  DispositivosEnviados: "Bidalitako gailuak",
  DispositivosError: "Errorea duten gailuak",
  marcarNotificacionLeida: "Jakinarazpena lida bezala markatu edo desmarkatu",
  archivarNotificacion: "Jakinarazpena artxibatu edo desartxibatu",
  desmarcarNotificacionLeida: 'Jakinarazpena lida bezala desmarkatzeko sakatu "ONARTU"',
  marcarNotificacionLeida: 'Jakinarazpena lida bezala markatzeko sakatu "ONARTU"',
  tituloNotificacionLeida: "Jakinarazpena LIDA/EZ LIDA bezala markatu",
  recuperarNotificacion: 'Jakinarazpena berreskuratzeko sakatu "ONARTU"',
  archivarNotificacion: 'Jakinarazpena artxibatzeko sakatu "ONARTU"',
  tituloArchivarNotificaciones: "Jakinarazpenak artxibatu",
  marcadaLeida: "Lida bezala markatua edo desmarkatua",
  marcadaArchivada: "Artxibatua bezala markatua edo desmarkatua",
  sinNombre: "Izenik gabe",
  sinApellido: "Abizenik gabe",
  LEIDA: "LIDA",
  NOLEIDA: "EZ LIDA",
  TostaNotificacionArchivada: "Jakinarazpena artxibatu da",
  TostaNotificacionDesarchivada: "Jakinarazpena jada ez dago artxibatuta",
  TostaNotificacionLeida: "Jakinarazpena lida bezala markatu da",
  TostaNotificacionNoLeida: "Jakinarazpena ez lida bezala markatu da",
  TituloDispositivosUsuario: "Erabiltzailearen gailuen taula ",
  conERROR: " ERROREArekin",
  TextoNotificacion: "Jakinarazpenaren testua",
  UrlAdjunta: "Erantsitako URLa",
  envioDispositivoCorrecto: "Abisua ongi bidali eta jaso da gailuan",
  envioDispositivoIncorrecto: "Abisua ezin izan da bidali eta ez da gailuan jaso",
  errorEnvioNoti: "Ezin izan da abisua bidali eta ez da jaso posible diren gailu guztietan (",
  errorEnvioNoti1: "Ezin izan da abisua bidali eta ez da jaso ",
  errorEnvioNoti2: " gailuetan, guztira ",
  errorEnvioNoti3: " bidali dira",
  exitoEnvioDispositivos: "Gailu guztiek abisua ongi jaso dute",
  NavegarJunta: "Batzarrera nabigatu",
  tip_asistirJunta: "Asistentzia",
  tituloAsistencia: "Asistentziaren xehetasuna",
  datosAsistencia: "Asistentziaren datuak",
  ASISTENCIA_REMOTA_APP_DELEGADO: "URRUTIKO - APP DELEGATUA",
  ASISTENCIA_REMOTA: "URRUTIKO",
  ASISTENCIA_REMOTA_ENLACE_VIDEO: "URRUTIKO - BIDEO-ESTEKA",
  ENLACE: "ESTEKA",
  APP: "APP",
  ASISTENCIA_FISICA_QR: "FISIKOA QR",
  ASISTENCIA_FISICA_FORMULARIO: "FISIKOA FORMULARIOA",
  ASISTENCIA_FISICA_FORMULARIO_NO_PROPIETARIO: "FISIKOA FORMULARIOA + EZ JABEA",
  ASISTENCIA_FISICA: "FISIKOA",
  ASISTENCIA_DELEGADA: "DELEGATUA",
  ASISTENCIA_: `\u00A0`,
  rojo_usuarioDesactivado: "Erabiltzaile hau oraindik ez dago erregistratuta C365-en",
  ErrorRecuperandoDatosAsistente: "Errore bat gertatu da asistentearen datuak berreskuratzean",
  DelegadoEn: "Honi delegatua",
  usuarioHaVotado: "Erabiltzaileak bozkatu du",
  NuevoAsistente: "Asistente berria",
  NoEstasRegistradoAPP: "Ez zaude erregistratuta APPn",
  usuarioSinVotar: "Erabiltzaileak parte hartu du baina ez du bozkatu",
  ErrorSeleccionOpcionVotacion:
    "Bozketaren aho batezko izaera hautatu duzu baina ez duzu aukerarik hautatu",
  ErrorSeleccionResultadoVotacion:
    "Bozketaren aho batezko izaera hautatu duzu baina ez duzu emaitzarik hautatu",
  Abs: "Abs",
  JuntaSinConexion: "Konexiorik gabeko bilera",
  AutoRellenarDNI:
    "Sartu zure NANa zure datuak automatikoki betetzeko, komunitatearen datu-basean bazaude",
  UsuarioNoRegistradoEnApp:
    "Komunitatearen datu-basean aurkitu zaitugu, baina ez zaude APPn erregistratuta. Nahi duzu email bat bidaltzea beharrezko urratsekin alta eman ahal izateko?",
  TipoVotacion: "Bozketa mota",
  QuitarAsistencia:
    "Batzarreko asistentzia kenduko duzu, erabiltzaileari lotutako boto guztiak ezabatuko dira batzar horretan",
  VerFichajes: "Fitxaketak ikusi",
  PRESIDENTE: "Presidentea",
  FIRMANTES: "Behean sinatzen dugunok",
  SeleccionaConvocante: "Aukeratu deitzailea",
  PrimC: "1. dei.",
  SegC: "2. dei.",
  TipoJunta: "Asistentzia mota",
  TituloConexion: "Konexioaren titulua",
  AbrirEnlacePestanaNueva: "Esteka beste fitxa batean ireki",
  Paso: "Urratsa",
  OcultarTutorial: "Tutoriala ezkutatu",
  VerTutorial: "Tutoriala ikusi",
  Destinatarios: "Hartzaileak",
  Crear: "Sortu",
  AQuienVaDirigida: "Nori zuzenduta dago?",
  CuandoYDonde: "Noiz eta non?",
  TipRolesJuntas: "(Berez, jabe guztiak, aukeratu rol bat edo batzuk)",
  Servicios: "Zerbitzuak",
  ProcesoAltaComunidad: "Komunitatearen alta-prozesua",
  ListaContratos: "Kontratuen zerrenda",
  IrADocumentacion: "Batzarraren dokumentaziora joan",
  EstadoActual: "Uneko egoera",
  Publicada: "Argitaratua",
  NoPublicada: "Argitaratu gabe",
  NoPublicar: "Desargitaratu",
  AsistentesConvocados: "Deitutako asistenteak",
  AsistentesConfirmados: "Berretsitako asistenteak",
  GenerarQR: "QRa sortu",
  QRdeLaJunta: "Batzarraren QR kodea",
  TipoConexion: "Konexio mota",
  DeshabilitarControlAsistencia: "Asistentzia-kontrola deshabilitatu",
  HabilitarControlAsistencia: "Asistentzia-kontrola gaitu",
  Habilitado: "Gaituta",
  Deshabilitado: "Desgaituta",
  TituloVotacion: "Bozketaren titulua",
  EsParaJunta: "Batzar baterako da?",
  TipJuntasVotaciones: "Batzar baterako bada, aukeratu zerrendatik bat",
  TipoVotacion: "Bozketa mota",
  OpcionesVotacion: "Bozketa-aukerak",
  NingunaDeLasOpciones: "Aukeretako bat ere ez",
  CriteriosVotacion: "Gehiengo aukera",
  AbrirVotacion: "Bozketa ireki",
  CerrarVotacion: "Bozketa itxi",
  VotacionAbierta: "Bozketa irekita",
  VotacionCerrada: "Bozketa itxita",
  NoPublicarResultado: "Emaitza desargitaratu",
  PublicarResultado: "Emaitza argitaratu",
  ResultadoNoPublicado: "Emaitza ez da argitaratu",
  NoPublicarPorcentaje: "Ez erakutsi portzentajea",
  PublicarPorcentaje: "Erakutsi portzentajea",
  PorcentajeNoPublicado: "Portzentajea erakusten",
  PorcentajePublicado: "Portzentajea ez erakusten ",
  Votos: "Botoak",
  totalVotosActa: "Boto guztiak : ",
  sumaTotalHoras: "Orduen batura guztira",
  QRfichar: "Fitxatzeko QR",
  enPrep: "en",
  contratoanadir: "Kontratua gehitu",
  contratoanadira: "Kontratua gehitu ",
  OcultarContratosCaducados: "Iraungitako kontratuak ezkutatu",
  MostrarContratosCaducados: "Iraungitako kontratuak erakutsi",
  tituloEnvioAvisoVotacion: "Bozketari buruzko jakinarazpena",
  ContratoHisotrico: "Kontratu iraungia",
  RegistroDeContratros: "Kontratuen erregistroa",
  OcultarIconosApp: "Funtzionalitateen bistaratzea mugikorreko app-ean komunitate honetarako",
  VerJuntas: "Batzarrak ikusi",
  Seguro: "Seguroa",
  Energia: "Energia",
  Mantenimiento: "Mantentzea",
  Reformas: "Berrikuntzak",
  VerFacturas: "Fakturak ikusi",
  VerTutorial: "Tutoriala ikusi",
  RegistroIncidencias: "Gorabeheraren erregistroa",
  Compartida: "Partekatu",
  SinCompartir: "Partekatu gabe",
  DocumentacionDeLaIncidenciaInfo: "Gorabeheraren dokumentazioa igo, deskargatu edo ikusi",
  BotonSOS: "SOS botoia",
  NoPublicarIncidencia:
    "Ezin da gorabehera bat partekatu, baldin eta argitaratu, itxi edo ezeztatu gabe badago",
  RegistradoPor: "Nork erregistratua",
  NoEliminarOpcionNinguna: "Gutxienez bozketa aukera bat egon behar du",
  ActividadesTitle: "Jarduerak",
  CiaSegurosComunidad: "Komunitatearen aseguru-etxea",
  ListadoDeActividades: "Jardueren zerrenda",
  DetalleComunidad: "Komunitatearen xehetasuna",
  OcultoAPP: "APPn ezkutua",
  VisibleAPP: "APPn ikusgai",
  ZonasComunes2: "Erreserbak",
  PermisosDeAcceso: "Sarbide-baimenak",
  NIFNIE: "NIF / NAN / IFK",
  DocumentacionInfo: "Komunitatearen dokumentazioa deskargatu edo ikusi",
  CentrosTrabajoNavegar: "Lan-zentroetara nabigatu",
  anadirDirecciones: "Helbideak gehitu",
  anadirDireccion: "Helbidea gehitu",
  funcionesNoDisponibles:
    "* Funtzionalitate batzuk ez dira erabilgarri egongo, erabiltzailea ez delako aplikazioan erregistratu",
  solicitarConfirmacionEmail: "Email kontuaren baieztapena eskatu",
  restablecerContrasena: "Pasahitza berrezarri",
  seleccionaTipo: "Aukeratu mota",
  UsuarioNoCreado: "Erabiltzailea ez da sortu, mesedez, saiatu berriro",
  cambiarContrasenaUser: "Erabiltzailearen pasahitza aldatu",
  VerificarEmail: "Emaila egiaztatu",
  EliminarUser: "Erabiltzailea ezabatu",
  verRegistroHorario: "Ordu-erregistroa ikusi",
  verFichajesUsuario: "Erabiltzailearen fitxaketak ikusi",
  EstadoActual: "Uneko egoera",
  CentrosAsignadosDetalle: "Esleitutako lan-zentroak",
  planContratadoActivo: "Kontratatutako plan aktiboa:",
  actualizarModificarPack: "Packa eguneratu / aldatu",
  darDeBaja: "Baja eman",
  descargarPrecios: "Prezioak deskargatu",
  Plan: "Plana",
  iban: "IBAN",
  numeroIban: "IBAN zenbakia",
  Vecinos: "Auzokideak",
  Periodicidad: "Aldizkakotasuna",
  Precio: "Prezioa",
  ViviendasEnComunidad: "Komunitateko etxebizitzak",
  EmailVerificado: "Emaila egiaztatuta",
  envioConfirmacionEmail: "Baieztapen-emaila bidali",
  AvisosP: "Jakinarazpena / emaila bidali erabiltzaileari.",
  FicharDesactivado: "Fitxatzea desaktibatuta",
  AsociarUsuariosCentroTrabajo: "Erabiltzaileak lan-zentroarekin lotu",
  IncidenciasRecibiraUsuario:
    "Zein komunitatetatik jasoko ditu gorabeherak administratzaile-erabiltzaile honek",
  AsignalRolPorComunidad: "Rola komunitateka esleitu",
  DocumentacionInfoUsers: "Dokumentazio konfidentziala bidali erabiltzaileei",
  otorgarPermisosUsuarios: "Baimenak eman erabiltzaileei",
  RecibirAverias: "Avariak jaso",
  TipoDeConvocatoria: "Batzar mota",
  votoDelegado: "Boto delegatua",
  Leida: "Lida",
  SinLeer: "Irakurri gabe",
  ErrorSegundaConvocatoria: "Bigarren deialdia ezin da lehenengoa baino lehenagokoa izan",
  Archivada: "Artxibatua",
  SinArchivar: "Artxibatu gabe",
  TelefonoNoValido: "Telefonoaren formatua ez da baliozkoa, mesedez, sartu zuzen bat.",
  ViviendasSolicitadasEnComunidad: "APPko erregistroan eskatutako etxebizitza",
  usuarioSinInstancia:
    "Erabiltzailea aplikazioan erregistratu da baina ez du lotutako instantziarik",
  adjudicarInstancia: "Instantzia erabiltzaileari esleitu",
  rechazarAdjudicacion: "Instantzia esleipena ukatu",
  adjudicacionRechazadaExito: "Eskaera ukatu da",
  adjudicacionRechazadaFallo: "Fallo bat gertatu da eskaera ukatzean",
  confirmarRechazarAdjudicacion: "Instantzia esleipenaren eskaera ukatu nahi duzu?",
  viviendaSolicitada: "APPko erregistroan eskatua",
  ResultadoEnviosNotificaciones: "Jakinarazpenen bidalketen emaitza",
  usuarioNoEncontradoEnComunidad:
    "Erabiltzailea ez da aurkitu komunitatearen datu-basean, jabea ez bazara markatu ez jabea naizen laukia",
  JuntaYaBorrada: "Batzarra jada ezabatu da",
  VisualizarAPP: "Ikonoak ikusi",
  VerIconosAPP: "Ikonoak ikusi / ezkutatu APPn",
  VisualizarAPPIconos: "Funtzionalitateen bistaratzea mugikorreko app-ean komunitate honetarako",
  JuntaYaBorradaQR: "Batzarra jada ezabatu da, ezin da QRa sortu",
  JuntaYaBorradaPublicar: "Batzarra jada ezabatu da, ezin da argitaratu",
  ConfigurarProveedores:
    "Osatu zure kontratatutako hornitzaileen datuak, abariak eta ezbeharrak kudeatzeko.",
  CrearCentrosTrabajo:
    "Gaitu langileak fitxatu ahal izateko (Ordu Kontrol Packa kontratatuta baduzu).",
  ConfigurarProveedores2: "Hornitzaileen konfigurazioa",
  MarcarActividades2: "Jarduerak markatu",
  AsociarProveedorAactividad: "Hornitzailea jarduera bati lotu",
  SubirDocumentos: "Dokumentuak igo",
  CrearJuntasYvotaciones: "Batzarrak eta bozketak sortu",
  AnadirZonasComunes: "Gune komunak gehitu",
  CrearCentrosDeTrabajo: "Lan-zentroak sortu",
  RegistroDeUsuarios: "Erabiltzaileen erregistroa",
  CrearZonas: "Gune komunak sortu",
  MostrarEnlace: "Esteka erakutsi",
  OcultarEnlace: "Esteka ezkutatu",
  CrearJuntas: "Batzarrak sortu",
  CrearVotaciones: "Bozketak sortu",
  AnadirZonasComunes2: "Lan-zentroak sortu ",
  Totales: "Totalak",
  VotoGuardadoCorrectamente: "Botoa ongi gorde da",
  AnadirVotoModificar: "Botoa gehitu / aldatu",
  SeleccionaUsuarioVotar: "Botoa emateko erabiltzaile bat aukeratu",
  SeleccionaOpcionVotar: "Botoa emateko aukera bat aukeratu",
  ErrorAdjudicandoInstancia: "Errore bat gertatu da instantzia esleitzean.",
  CodigoAdministracionEnUso: "Administrazio-kodea jada erabiltzen ari da",
  CodigoAdminitradorNoValido:
    "Balioak zehazki hiru letra izan behar ditu, jarraian zenbaki bat duela.",
  usuarioConInstanciaSinAdjudicar: "Erabiltzaileak esleitu gabeko instantzia bat du",
  BloquearZona: "Gunea blokeatu",
  errorBorrarIncidencia2:
    "Gorabeherak PECHADA edo CANCELADA egoeran daudenean bakarrik ezabatu daitezke",
  ReservaCanceladaCorrectamente: "Erreserba ongi ezeztatu da",
  Contacto: "Harremanetarako pertsona",
  enviadoscorrectosCabecera: "Jakinarazpenak ongi bidali dira",
  enviadosIncorrectosCabecera: "Errore bat gertatu da jakinarazpenak bidaltzean",
  enviadosTotalesCabecera: "Jakinarazpenak bidali dira",
  enviadoTotalesCabeceraTexto: "Bidalitako jakinarazpenen kopuru totala",
  Calle: "Kalea",
  ReferenciaExt: "Erreferentzia",
  CNAEDescripcion: "CNAEren deskribapena",
  DatosContratoGuardadosCorrectamente: "Kontratuaren datuak ongi gorde dira",
  Propiedades: "Propietateak",
  PropietariosVecinos: "Jabeak/Maizterrak/Enpresak/Lege-ordezkariak",
  DestinatarioConsulta: "Kontsultaren hartzailea",
  SlotReservadoDesbloquealo:
    "Slota blokeatuta dago. Erreserbatu nahi baduzu, lehenengo desblokeatu behar duzu.",
  CreadoDesde: "Nondik sortua",
  ProveedorRecibiraEmail:
    "* Hornitzaileak beti jasotzen du mezu elektroniko bat gorabeheraren aldaketekin",
  EnviarNotificaciones: "Jakinarazpenak bidali",
  enviarEmails: "Emailak bidali",
  ResetearBusqueda: "Bilaketa berrezarri",
  Recibos: "Ordainagiriak",
  RecibosDetalle: "Ordainagiriak ikusi",
  pagador: "Ordaintzailea",
  cobrador: "Kobratzailea",
  nif_cobrador: "Kobratzailearen NIFa",
  nif_pagador: "Ordaintzailearen NIFa",
  importe: "Zenbatekoa",
  fechaVencimiento: "Epemuga",
  comentario: "Iruzkina",
  totalEnterosActa: "Zenbaki osoak guztira : ",
  Pagado: "Ordaindua",
  pdtPago: "Ordainketa zain",
  totalPagado: "Ordaindutako guztira",
  RegistroDeAccesos: "Sarbideen Erregistroa",
  AbrirConexionReunion: "Bileraren konexioa",
  ErrorJuntaBorrada: "Ezin duzu konexioa ireki batzarra jada ezabatu bada",
  tooltip_emulador: "Komunitateko auzokideentzako simulazio bisuala bakarrik",
  emulador: "APP bistaratzea auzokideentzat",
  GenerarQR: "QRa sortu",
  RegistroHorarioDe: "Erabiltzailearen ordu-erregistroa :",
  Mes: "Hilabetea:",
  Semana: "Astea:",
  ArrastrarImagen: "Arrastatu edo askatu hemen irudia",
  SeleccionaOpcion: "Aukeratu aukera bat",
  MostrarArchivadas: "Artxibatutakoak erakutsi",
  FiltrarUsuariosAvisos: "Erabiltzaileak iragazi abisuak bidaltzeko",
  ContratoActual: "Uneko kontratua",
  ListaContratosHistoricos: "Kontratu historikoen zerrenda",
  ResolucionNecesaria: "* Gomendatutako ebazpena 1054px 444px",
  QueIncidenciasRecibira: "Zer gorabehera jasoko ditu administratzaile-erabiltzaile honek?",
  seleccionaPlanNecesidades: "Aukeratu zure beharretara gehien egokitzen den plana",
  Precios: "Prezioak",
  PackContratadoActual: "Kontratatutako pack aktuala",
  SeleccionaFormaPago: "Aukeratu ordainketa modua",
  PagoMensual: "Hileroko ordainketa",
  HasSeleccionadoPlan: "Hautatu duzu plana",
  ConFormaPago: "ordainketa moduarekin",
  PagoAnual: "Urteko ordainketa",
  ElPRecioTotal: "Prezio totala hau da",
  al: "a",
  Siguiente: "Hurrengoa",
  SeleccionaOpcionFacturacion: "Aukeratu fakturazio-aukera bat",
  IBANComunidad: "Komunitatearen IBANa",
  IBANAdministrador: "Administratzailearen IBANa",
  conLa: "koa",
  IBANElegido: "eta IBAN aukeratua hau da",
  cuentaBancariaEs: "eta banku-kontua hau da",
  ResumenServicios: "Kontratatutako zerbitzuen laburpena",
  DetalleServicios: "Jarraian, kontratatutako zerbitzuen laburpena zehazten da",
  PlanSeleccionado: "Hautatutako plana",
  IbanAsociado: "Lotutako IBANa",
  PrecioTotal: "Prezio totala",
  SiDeseasModificar:
    "Aldaketarik egin nahi baduzu, atzera egin dezakezu kontratazio-prozesuan eta dagokion urratsera itzuli.",
  Atentamente: "Adeitasunez",
  Empresa: "C365",
  PasoFinal: "Azken urratsa",
  ResumenDeLosDatosContratados: "Kontratatutako datuen laburpena",
  DescargarContrato: "Kontratua deskargatu",
  DireccionCompleta: "Helbide osoa",
  AlertaTitulo: "¡ALERTA! Bozketa motaren aldaketa garrantzitsuak",
  Mensaje1: "Bozketaren izaera hautatzean",
  Mensaje2: "eta aukera",
  Mensaje3: "Botoa esleituko zaio",
  Mensaje4: "une honetako boto-emaile guztiei",
  ResultadoEnvio: "Bidalitakoaren emaitza",
  TokenDispositivo: "Gailuaren tokena",
  ErrorTipo: "Errore-mota",
  DetalleMensajeError: "Errore-mezuaren xehetasuna",
  PrimeraVezPago: "Lehenengo aldia da ordainketa bat egiten duzula karguaren gainean",
  ConEstaCuenta: "kontu honekin: ",
  PulsaConfirmarPago: "Sakatu baieztatu ordainketa hau eta hurrengoak kargatzeko.",
  ConfirmarIban: "IBANa baieztatu :",
  Confirmar: "Baieztatu",
  Volver: "Itzuli",
  VolverPrimerPaso: "1. urratsera itzuli",
  MostrarVotosBorradas: "Boto ezabatuak erakutsi",
  OcultarVotosBorradas: "Boto ezabatuak ezkutatu",
  ElAdminHaBorradoVotacion: "Administratzaileak bozketa ezabatu du",
  NoBorrarActividadConContratos: "Ezin da jarduera bat ezabatu kontratu lotuak dituelako",
  HazClicAquiParaAcceder: "Egin klik hemen sartzeko",
  CifRepetido: "IFKa jada erabiltzen ari da beste hornitzaile batean",
  SuperAdministrador: "Super Administratzailea",
  DeshacerCambios: "Aldaketak desegin",
  Entendido: "Ulertua",
  comunidadIbanDiferente: "Uneko IBANa kontratu aktiboan agertzen denarekiko desberdina da.",
  NoTienesAcceso:
    "Ez duzu funtzionalitate honetarako sarbiderik, hasierako orrialdera bideratzen zaitugu",
  MostrarDatosAdminToast: "Administratzailearen bulegoko datuak erakutsiko dira",
  NoMostrarDatosAdminToast: "Administratzailearen bulegoko datuak ez dira erakutsiko",
  MostrarDatosDespacho: "Bulegoko datuak erakutsi",
  MostrarRecibosComunidades: "Komunitatearen etorkizuneko ordainagiriak erakutsi",
  MarcarFuturosRecibosComunidad: "Komunitatearen etorkizuneko ordainagiriak markatu",
  MarcarFuturosRecibosUsuarios: "Erabiltzaileen etorkizuneko ordainagiriak markatu",
  Mostrar: "Erakutsi",
  NoMostrar: "Ez erakutsi",
  RecibosComunidad: "Komunitatearen ordainagiriak",
  RecibosUsuarios: "Erabiltzaileen ordainagiriak",
  VerEnLaAPP: "APPn ikusi",
  PublicarFuturosRecibos: "Etorkizuneko ordainagiriak argitaratu",
  Publicados: "Argitaratuak",
  SinPublicar: "Argitaratu gabe",
  usuarioVotoBorrado: "Botoa ezabatuta dago",
  ContratoGuardadoCorrectamente: "Kontratua ongi gorde da",
  ArchivoBorradoCorrectamente: "Fitxategia ongi ezabatu da",
  yaExisteEnOtroDespacho:
    "Komunitatea jada existitzen da eta alta emanda dago beste bulego batean, jarraitu ahal izateko aurretik baja eman behar zaio beste bulego horretan.",
  FechaUltimoAcesso: "Azken sarbide data",
  rojo_usuarioBloqueado: "Erabiltzaile hau blokeatuta dago",
  ReferenciaExterna: "Kanpoko erreferentzia",
  titloCambiarEstadoVotacion: "Bozketaren egoera aldatu: ",
  estasSeguroCambiarEstado: "Ziur zaude bozketa-egoera aldatu nahi duzula?",
  VotacionEstadoModificado: "Bozketaren egoera ongi aldatu da",
  FechaUltimoAcceso: "Azken sarbide data",
  ReservasNoValidas: "Erreserba-eskubidea ez da baliozkoa, 0 edo 1 izan behar du",
  pendienteValidarEmail: "Erabiltzaile hau jada erregistratu da, emaila balioztatzeke dago.",
  ErrorUsuarioNoCreado: "Ezin duzu blokeatu/desblokeatu alta emanda ez dagoen erabiltzaile bat",
  EmailRequerido: "Emaila beharrezkoa da posta egiaztatzeko",
  todosCentroDeTrabajoSeleccionados: "Lan-zentroko erabiltzaile guztiak hautatu dira",
  LimpiarBusqueda: "Bilaketa garbitu",
  limpiarSeleccionados: "Hautatutakoak garbitu",
  seleccionarTodos: "Guztiak hautatu",
  seleccionarTodosFiltrado: "Guztiak hautatu (iragazitakoak)",
  todasLasComunidadesHanSidoSeleccionadas: "Komunitate guztiak hautatu dira",
  noHayCentroDeTrabajo: "Ez dago lan-zentrorik",
  centrosDeTrabajo: "Lan-zentroak",
  noHayComunidades: "Ez dago komunitaterik",
  todasComunidadesPorDefecto: "Komunitate guztiak lehenespenez",
  todosLosRolesHanSidoSeleccionados: "Rol guztiak hautatu dira",
  noHayRoles: "Ez dago rolik",
  seleccionarRoles: "Rolak hautatu",
  EmailIntegracion: "Integrazio-emaila",
  AltaCorrectaDemo: "Alta zuzena demoan",
  CodigoIncorrectoDemo: "Sartutako kodea ez da zuzena",
  IntroduceCodigoGratiws: "Sartu kodea C365-en alta emateko",
  avisoBajaVecinosTitulo: "BAJA ABISUA",
  avisoBajaAdministradorTitulo: "BAJA ABISUA",
  avisoBajaVecinos:
    "Zure administratzaileak c365 aplikazioari baja eman dio zure komunitatean, oraindik jakinarazpenak soilik ikusi ahal izango dituzu aplikazioan, zure komunitateak zerbitzuak berraktibatu arte.",
  avisoBajaAdministrador:
    "c365 plataformari baja emateko eskaera jaso dugu, hemendik aurrera ez da aktiboa izango plataforman",
  conservarDatos1:
    "Komunitate honek alta eman zuen jada c365-en, datu guztiak berreskuratu nahi dituzu?",
  conservarDatos2:
    "Aurreko konfigurazioa gordetzen ez baduzu, kontuan izan erabiltzaile guztiek aplikazioan berriro erregistratu beharko dutela. Hala ere, datuak gorde nahi ez badituzu, sakatu “Ez Gorde”, bestela “Datuak Gorde”",
  ValidadoEnOtraComu:
    "Erabiltzailea balioztatuta dago baina EZ dago alta emanda komunitate honetan",
  idErp: "Erp IDa",
  tokenTitulo: "Saioa iraungitzear dago",
  tokenCuerpo: "Saioa berritu nahi duzu?",
  ErrorVerificandoEmail: "Errorea emaila egiaztatzean",
  ordenActualizado: "Agindua ongi eguneratu da",
  detectedComu:
    "Komunitate honek jada alta eman zuen c365-en, datu guztiak berreskuratu nahi dituzu?",
  RecoverOldData: "Datu guztiak berreskuratu",
  VisualizarAPPIconosDespacho:
    "Mugikorreko app-eko funtzionalitateak bulego guztientzat bistaratzea",
  Sos: "SOS",
  Seguros: "Aseguruak",
  todoVisible: "Komunitate guztietan ikusgai",
  DNIYaExisteEnLaComu: "NANa jada existitzen da bulego honetan, mesedez, sartu beste bat",
  ArrastrarSoltarImagen: "Arrastatu edo solta hemen irudia",
  altaOtroDesk: "Erabiltzailea jada alta emanda dago bulegoan",
  enLasComus: " eta komunitate hauetan: ",
  RedimensionarImagen: "Irudia ongi redimensionatu da 1054px x 444px-ra",
  comunidadFalta: "Eremua falta da : ",
  comunidadFaltaImportante: "Hau esleitzea falta da ",
  comunidadFaltaImportante2: " bete ezazu jardueretan",
  DNIotracomunidad: "Erabiltzaile bat antzeman dugu NAN bera duena beste komunitate batean",
  anadirloComunidad: "Komunitate honetara gehitu nahi duzu?",
  votacionBorrada2: "Ezin duzu bozketa ezabatua aldatu",
  Responsable: "Arduraduna",
  SeleccionaResponsable: "Aukeratu arduradun bat",
  ApellidoResponsable: "Arduradunaren abizena",
  SuscripcionDespacho: "CAFcomunidad lizentzia",
  DetallesLicencia: "Lizentzia ikusi / desaktibatu",
  procesoActivacionComunidad: "Komunitatearen aktibazio-prozesua",
  ResumenDeLaContratacion: "Kontratazioaren laburpena",
  DespachoSinIBAN:
    "Bulego honek ez du lotutako IBANik, arazo hau konpontzeko itxi fitxa hau, gehitu IBANa CAFportaleko bulegoan eta sartu berriro CAFcomunidaden",
  ConfirmaDatosYAceptaContinuar: "Berretsi datuak eta onartu baldintzak jarraitzeko",
  ContratarActivar: "CAFComunidad kontratatzean bulegoarentzat, hau aktibatuko duzu",
  SuscripcionMensualDe: "hileroko harpidetza ",
  RecibosIBANDespacho: "Ordainagiriak bulegoko IBANera pasatuko dira",
  DespachoSinIBAN:
    "Bulego honek ez du IBANik eta kontratazio-prozesua ezin da amaitu. Mesedez, gehitu CAFportal-etik.",
  DespachoNoActivado: "Zure bulegoa oraindik ez da aktibatu CAFcomunidaden!",
  ActivarSuscripcionParaUsar:
    "CafComunidad erabili ahal izateko, lehenik harpidetza aktibatu beharko duzu. Bitartean, aplikazioa erabil dezakezu eskuragarri duzun proba-komunitatearekin.",
  ContratarCAFComunidad: "CAFcomunidad kontratatu",
  ContratarCafComunidadEsteDespacho: "CAFcomunidad kontratatu bulego honetarako",
  ErrorAbrirNuevaVentana:
    "Errore bat gertatu da leiho berria irekitzean, ziurtatu baimenak dituzula leiho gainerakorrak irekitzeko.",
  ComunidadActivadaCorrectamente: "Komunitatea ongi aktibatu da",
  DeseasActivarComunidad: "Komunitatea aktibatu nahi duzu?",
  DeseasIniciarPagosComunidad: "Komunitatearen ordainketak hasi nahi dituzu?",
  PrecioComunidad: "Komunitatearen prezioa",
  Con: "rekin",
  VecinosEsDe: "auzokide ditu, eta honen prezioa da",
  AlMes: "hilean",
  NumeroCuentaBancaria: "Banku-kontuaren zenbakia hau da",
  ComunidadNoIBAN: "Komunitateak ez du IBANik, mesedez, sartu CAF portalera eta gehitu",
  CambiarIdioma: "Hizkuntza aldatu",
  ConfirmarCambiarIdioma: "Hizkuntza aldatzen baduzu, baliteke lantzen ari zinen aldaketak galtzea",
  agendarImportacionTitulo: "Datuen inportazioa antolatu",
  agendarImportacionDescripcion: "Sakatu hemen zure datuak inportatzeko hitzordua antolatzeko",
  //Ultima revision 04-09
};
/*
export const diccionario_eu = new Proxy(diccionario_eu_base, {
  get(target, prop) {
    // If prop is a Symbol (like Symbol.toStringTag), return the default behavior
    if (typeof prop === "symbol") {
      return Reflect.get(target, prop);
    }
    // Otherwise, return the translated value or the fallback
    return prop in target ? target[prop] : `${String(prop)} [sin trad.]`;
  }
});
*/

export const tableLocation_eu = {
  pagination: {
    labelRowsSelect: "Filas por página",
    labelDisplayedRows: "{from}-{to} de {count}",
    firstAriaLabel: "Primera página",
    firstTooltip: "Primera página",
    previousAriaLabel: "Página anterior",
    previousTooltip: "Página anterior",
    nextAriaLabel: "Siguiente página",
    nextTooltip: "Siguiente página",
    lastAriaLabel: "Última página",
    lastTooltip: "Última página",
  },
  toolbar: {
    searchTooltip: "Buscar",
    searchPlaceholder: "Buscar",
    nRowsSelected: "{0} filas(s) seleccionada(s)",
  },
  header: {
    actions: "Acciones",
  },
  body: {
    emptyDataSourceMessage: "No hay datos disponibles",
    filterRow: {
      filterTooltip: "Filtrar",
    },
    editRow: {
      saveTooltip: "Guardar",
      cancelTooltip: "Cancelar",
      deleteText: "¿Estás seguro de querer borrar esta fila?",
    },
    addTooltip: "Agregar fila",
    deleteTooltip: "Borrar fila",
  },
  edit: {
    saveTooltip: "Guardar",
    cancelTooltip: "Cancelar",
    deleteText: "¿Estás seguro de querer borrar esta fila?",
  },
  group: {
    deleteTooltip: "Borrar grupo",
    editTooltip: "Editar grupo",
    addTooltip: "Agregar grupo",
  },
};
